import { injectGlobal } from "styled-components";

/* eslint no-unused-expressions: 0 */
injectGlobal`
  :root {
    --white-100-50: rgba(255, 255, 255, 0.5);
    --f-5-f-6-fa-blue-05: #f5f6fa;
    --black-100-50: rgba(0, 0, 0, 0.5);
    --navy-100: #001f4e;
    --navy-90: #19355f;
    --navy-80: #334c71;
    --navy-70: #4c6283;
    --navy-60: #667995;
    --navy-50: #7f8fa6;
    --navy-40: #99a5b8;
    --navy-30: #b2bbc9;
    --navy-20: #ccd2dc;
    --navy-10: #e5e8ed;
    --bright-blue-100: #2dccd3;
    --bright-blue-90: #42d1d7;
    --bright-blue-80: #57d6dc;
    --bright-blue-70: #6cdbe0;
    --bright-blue-60: #81e0e5;
    --bright-blue-50: #96e5e9;
    --bright-blue-40: #abebed;
    --bright-blue-30: #c0eff1;
    --bright-blue-20: #d5f5f6;
    --bright-blue-10: #eaf9fa;
    --bright-gray-100: #b1b3b3;
    --bright-gray-90: #b8baba;
    --bright-gray-80: #c1c2c2;
    --bright-gray-70: #c8c9c9;
    --bright-gray-60: #d0d1d1;
    --bright-gray-50: #d8d9d9;
    --bright-gray-40: #e0e1e1;
    --bright-gray-30: #e7e8e8;
    --bright-gray-20: #eff0f0;
    --bright-gray-10: #f7f7f7;
    --gold-100: #ffa300;
    --gold-90: #ffac19;
    --gold-80: #ffb533;
    --gold-70: #ffbe4c;
    --gold-60: #ffc866;
    --gold-50: #ffd17f;
    --gold-40: #ffda99;
    --gold-30: #ffe3b2;
    --gold-20: #ffedcc;
    --gold-10: #fff5e5;
    --raspberry-100: #bb1057;
    --raspberry-90: #c12767;
    --raspberry-80: #c94079;
    --raspberry-70: #cf5789;
    --raspberry-60: #d6709a;
    --raspberry-50: #dd87ab;
    --raspberry-40: #e49fbc;
    --raspberry-30: #eab7cc;
    --raspberry-20: #f1cfdd;
    --raspberry-10: #f8e7ee;
    --blue-100: #425cc7;
    --blue-90: #546ccc;
    --blue-80: #4a6aa7;
    --blue-70: #607cb2;
    --blue-60: #778fbd;
    --blue-50: #8ea2c8;
    --blue-40: #a5b5d3;
    --blue-30: #bbc7de;
    --blue-20: #d9def4;
    --blue-10: #eceef9;
    --dark-gray-100: #4d4d4f;
    --dark-gray-90: #5e5e60;
    --dark-gray-80: #717172;
    --dark-gray-70: #828283;
    --dark-gray-60: #949495;
    --dark-gray-50: #a6a6a7;
    --dark-gray-40: #b8b8b9;
    --dark-gray-30: #c9c9ca;
    --dark-gray-20: #dbdbdc;
    --dark-gray-10: #ededed;
    --error-red-100: #e11f3b;
    --white-50: #ffffff;
    --white-50p: rgba(255, 255, 255, 0.5);
    --black-100: #000000;
    --black-50p: rgba(0, 0, 0, 0.5);

    // these colors come from react-bootstrap, to be used for custom input components
    --border-color: #ced4da;
    --border-color-highlight: #80bdff;
    --border-color-highlight-box-shadow: 0 0 0 .2rem rgba(0,123,255,.25);
    --background-color-selected: rgba(0, 126, 255, 0.04);
    --background-color-highlight: rgba(0, 126, 255, 0.08);

    // these colors are standard platform colors
    --primary-color: #2AC6CD;
    --secondary-color: #425cc7;
    --background-color: #F6F6F6;
    --background-color-disabled: #c6ceee;
    --warning-color: var(--gold-100);
    --error-color: var(--error-red-100);
    --disabled-color: var(--dark-gray-30);
  }

  html,
  body {
    height: 100%;
    width: 100%;
    background-color: #F6F6F6;
  }

  body {
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body, th, td, input, textarea, .btn, .dropdown-menu, .form-control {font-size: 13px;}

  body.fontLoaded {
    font-family: Lato, 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .blackLink {
    color: #000;
    text-decoration: none;
    margin: 0;
    padding: 0;
    border: 0;
    text-align: left;
  }

  .blackLink:hover {
    text-decoration: underline;
  }

  .blackLinkInactive {
    color: #828283;
    text-decoration: none;
    margin: 0;
    padding: 0;
    border: 0;
    text-align: left;
  }

  .blackLinkInactive:hover {
    text-decoration: underline;
  }

  .text-smaller {
    font-size: .85em;
  }

  .text-larger {
    font-size: 1.2em;
  }

  .pageHeader {
    font: 24px Montserrat, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #163E97;
    margin-top: 0;
  }

  h5 {
    font-weight: 600;
  }

  h6 {
    font-weight: 600;
  }

  #app {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Lato, Arial, Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  .start-0{
    left: 0 !important;
  }

  .form-check-input-style > .form-check-input {
    margin-top: 2px;
  }

  #candidate-profile ul.nav-tabs li a {
    padding: 5px 15px;
  }

  #candidate-profile ul.nav-tabs {
    max-width: calc(100% - 220px);
    align-content: left;
  }

  .candidateCardName {
    font-size: 18px;
    font-weight: 600;
    padding-left: 10px;
  }

  .candidateCardTimeStamp {
    color: #A3A3A3;
    font-size: 10px;
    margin-left: 22px;
  }

  .candidateCardIcon {
    color: #999;
    font-size: .75em;
    margin: -7px 5px 0 0;
  }

  .candidateCardTests, .candidateCardVideoInterview {
    margin: 5px 0 5px 22px;
  }

  .candidateCardTable {
    margin-bottom: 0;
  }

  .candidateCardTable tbody tr td {
    border: 0;
    vertical-align: middle;
    padding: 0;
    margin: 0;
    background-color: #f7f7f7;
  }

  .candidateCardCloseButton {
    color: #21489D;
    background-color: none;
    border: 0;
    padding: 0;
    margin: 0;
    position: relative;
    top: -5px;
    right: -5px;
  }

  .candidateCardRating {
    font-size: 12px;
    margin-right: 15px;
  }

  .buttonAsLink, .buttonAsLinkNoHover {
    margin: -2px 0 0 0;
    padding: 0;
    text-decoration: underline;
    border: 0;
    color: #1F469A;
    font-size: inherit;
    outline: 0;
  }

  .buttonAsLink:hover {
    text-decoration: none;
    background-color: #FFF;
  }

  .buttonAsLinkDisabled {
    margin: -2px 0 0 0;
    padding: 0;
    border: 0;
    font-size: inherit;
    outline: 0;
  }

  .colorPickerBox {
    margin: 0;
    overflow: hidden;
    cursor: pointer;
    padding: 4px 10px;
    display: inline-block;
    border: 1px solid #91765d;
    border-radius: 2px;
    font-size: 12px;
    background: #eee;
    color: #333;
    vertical-align: middle;
  }

  .howToGuides {
    margin: 0 0 25px 0;
    padding: 0;
    list-style: none;
  }

  .howToGuides li button {
    margin: 0;
    padding: 0;
    text-decoration: underline;
    border: 0;
    color: #1F469A;
    font-size: 14px;
    font-weight: 500;
    outline: 0;
  }

  .howToGuides li button:hover {
    text-decoration: none;
    background-color: #FFF;
  }

  .jobSetupPanel .panel {
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .jobSetupPanel .panel-default {
    border: 0;
  }

  .jobSetupPanel .panel-heading {
    background-color: #FFF;
    border: 0;
  }

  .jobSetupPanel .panel-body {
    background-color: #FFF;
    border: 0;
  }

  .jobSetupPanel .panel-group .panel-heading+.panel-collapse > .list-group, .panel-group .panel-heading+.panel-collapse>.panel-body {
    border: 0;
  }

  .DraftEditor-root {
    height: 150px !important;
  }

  .table tbody tr td {
    font-family: Lato, Helvetica, Arial, sans-serif;
  }

  .table-active td, .table-inactive td {
    vertical-align: middle;
  }

  /* .table-inactive {
    background-color: #F6F6F6;
  } */

  .candidateCardRating {
    color: #C0DEDD;
    font-size: 12px;
    margin-right: 15px;
  }

  .table-inactive td {
    color: #A2A2A2;
  }

  .textLink:hover {
    text-decoration: underline;
  }

  .pointerHover:hover {
    cursor: pointer;
  }

  .btn-criteria-primary {
    background-color: #1E469B;
    border: 0;
  }

  .actionDropdownItem {
    ${"" /* font-size: 12px; */}
  }

  #custom-date-range-dropdown-item:hover, #custom-date-range-dropdown-item:active {
    color: inherit;
    background-color: inherit;
  }

  .btn-criteria-toggle {
    font-family: Montserrat, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    padding: 2px 15px;
    font-size: 12px;
  }

  .jobSelector-job {
    font: 700 15px Lato, Helvetica, Arial, sans-serif;
  }

  .jobSelector-job-large {
    font: 700 18px Lato, Helvetica, Arial, sans-serif;
  }

  .jobSelector-location {
    font-size: 11px;
    font-family: Lato, Arial, Helvetica, sans-serif;
  }

  .job-dropdown-item {
    font-size: 16px;
  }

  .job-dropdown-item.job-header {
    width: 100%;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px;
  }

  .analytics-exclude-filters {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px
  }

  .analytics-exclude-filters p {
    margin-bottom: 0;
  }

  #exclude-filters {
    margin-left: 10px;
  }

  .analytics-exclude-filters-dropdown {
    padding: .9rem .5rem;
    min-width: 15rem;
  }

  .job-dropdown-item.results-landing {
    margin: 10px 0;
    width: 700px;
  }

  .testPortfolioListItem {
    margin-bottom: 4px;
  }
  .testPortfolioList {
    width: 100%;
    border: none;
    white-space: normal;
    text-align: left;
    margin: 0;
    padding: 5px;
  }

  .candidateDataAddBox {
    background-color: #D5F5F6;
    border: 1px solid #999;
    text-align: left;
    width: 100%;
    padding: 5px 10px;
  }

  .criteriaTestsAddBox {
    background-color: #D9DEF4;
    border: 1px solid #999;
    text-align: left;
    width: 100%;
    padding: 5px 10px;
  }

  .testMakerTestsAddBox {
    background-color: #E5E8ED;
    border: 1px solid #999;
    text-align: left;
    width: 100%;
    padding: 5px 10px;
  }

  .videoAssessmentAddBox {
    background-color: #CCEEF9;
    border: 1px solid #999;
    text-align: left;
    width: 100%;
    padding: 5px 10px;
  }

  .columnBox {
    border: 1px solid #AFB0B1;
    padding: 5px 10px;
    display: inline-block;
    width: 100%;
    margin-bottom: 3px;
    &:hover {
      cursor: move;
    }
    & > span {
      visibility: hidden;
    }
    &:hover > span {
      visibility: visible;
    }
    &:hover > button {
      text-decoration: underline;
    }
  }

  .dragHandle {
    position: absolute;
    top: 5px;
    left: 5px;
    cursor: move;
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webskit-grab;
    cursor: url(https://ssl.gstatic.com/ui/v1/icons/mail/images/2/openhand.cur), default !important;
  }

  .custom-extra-large-modal {
    width: 90%;
    max-width: 1200px;
  }

  .scoringDataLabel {
    font-family: Lato, 'Helvetica Neue', Helvetica, Arial, sans-serif;
    text-transform: uppercase;
    font-size: 10px;
    color: #999;
    text-align: center;
    white-space: nowrap;
  }

  .criteria-label {
    background-color: #1E469A;
    color: #FFF;
  }

  .criteria-custom-tooltip {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: visible;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .criteria-custom-tooltip * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .criteria-custom-tooltip-zindex {
    position: absolute;
    left: -9999px;
    top: -9999px;
    visibility: visible;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    z-index: 9999;
  }
  .criteria-custom-tooltip-zindex * {
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .criteria-custom-tooltip-placement-top {
    padding: 4px 0 8px 0;
  }
  .criteria-custom-tooltip-zindex-placement-top {
    padding: 4px 0 8px 0;
  }
  .criteria-custom-tooltip-inner {
    padding: 6px 2px;
    min-width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    text-align: center;
    text-decoration: none;
    background-color: #6c6c6c;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }
  .criteria-custom-tooltip-zindex-inner {
    padding: 6px 2px;
    min-width: 24px;
    height: 24px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    text-align: center;
    text-decoration: none;
    background-color: #6c6c6c;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }
  .criteria-custom-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .criteria-custom-tooltip-zindex-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .criteria-custom-tooltip-placement-top .criteria-custom-tooltip-arrow {
    bottom: 4px;
    left: 50%;
    margin-left: -4px;
    border-width: 4px 4px 0;
    border-top-color: #6c6c6c;
  }
  .criteria-custom-tooltip-zindex-placement-top .criteria-custom-tooltip-zindex-arrow {
    bottom: 4px;
    left: 50%;
    margin-left: -4px;
    border-width: 4px 4px 0;
    border-top-color: #6c6c6c;
  }

  .sortHandle {
    float: left;
    margin-left: 10px;
    margin-top: 6px;
    cursor: move;
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webskit-grab;
    cursor: url(https://ssl.gstatic.com/ui/v1/icons/mail/images/2/openhand.cur), default !important;
  }

  .managePipelineCreator {
    display: inline-block;
    background-color: #C6D0E5;
    text-align: center;
    margin-right: 5px;
    height: 37px;
    max-height: 37px;
    line-height: 37px;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: 'Montserrat';
    font-size: 12px;
    font-weight: 600;
  }

  .managePipelineCreator span.fa-close:hover {
    cursor: pointer;
    color: red;
  }

  .managePipelineArrow {
    height: 100%;
    width: 15px;
    z-index: 1000;
    background: url("https://s3.amazonaws.com/criteria-static-web-assets/results/pipeline_arrow_off_37.png");
    float: right;
  }

  .editableInput {
    display: inline;
    border: 1px solid #C6D0E5;
    line-height: 1;
    padding: 3px;
    border-radius: 2px;
  }

  .editableInput:hover {
    border: 1px solid #153F97;
  }

  .editableInput:focus {
    border: 1px solid #66AFE9;
  }

  .jobsLandingTable {
    border-collapse: separate;
    border-spacing: 0 20px;
  }

  .table tr.jobsLandingRow td {
    white-space: normal;
    padding-top: 25px;
  }

  table tr.jobsLandingRow td:first-child {
    padding-top: 22px;
    vertical-align: middle;
  }

  table tr.jobsLandingRow td:first-child input {
    font-size: 16px;
    margin-top: 0;
  }

  table.jobsLandingTable {
    margin-top: -20px;
  }

  .jobs-landing-table table thead tr th:first-child {
    border: 0;
  }

  .search-modal {
    width: 100vw;
    max-width: 70%;
    margin: 65px auto;
    padding: 0;
  }

  #search-input-text {
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #828283;
  }

  .advanced-search-filter-form {
    margin-top: '8px';
  }

  .advanced-search-title {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
  }

  .advanced-search-title-container {
    margin-bottom: 6px;
  }
  .advanced-search-text-input {
    margin-bottom: -20px;
  }

  .advanced-search-input-labels {
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  color: #000000;
  margin-bottom: 0px;
  }

  .advanced-search-date-input{
    width: 200px;
  }

  .modal-open .modal { outline: none; }

  .DayPickerInput input {
    border: 1px solid #C5C5C5;
    padding: 5px;
    border-radius: 4px;
    width: 96px;
    cursor: pointer !important;
  }

  .thinField-100 input {
    width: 100px;
  }

  .thinField-100 .form-control-feedback {
    left: 70px;
  }

  .thinField-150 input {
    width: 150px;
  }

  .thinField-150 .form-control-feedback {
    left: 120px;
  }

  .thinField-200 input {
    width: 200px;
  }

  .thinField-200 .form-control-feedback {
    left: 170px;
  }

  #zrPreview h1,
  #zrPreview h2,
  #zrPreview h3,
  #zrPreview h4,
  #zrPreview h5,
  #zrPreview h6 {
    font-family: 'Lato';
    font-weight: bold;
  }

  #zrPreview h1 {
    font-size: 36px;
  }

  #zrPreview h2 {
    font-size: 30px;
  }

  #zrPreview h3 {
    font-size: 24px;
  }

  #zrPreview h4 {
    font-size: 20px;
  }

  #zrPreview h5 {
    font-size: 15px;
  }

  #zrPreview h6 {
    font-size: 12px;
  }


  /**
   * Nested Dropdowns
   */

   .search-results-bulk-action-submenu {
     padding: 3px 0px 3px 24px;
   }

   .search-results-bulk-action-submenu>a{
     color: black;
   }

  .search-results-bulk-action-submenu:hover{
    background-color: #F7F8F9;
  }

  .search-results-bulk-action-submenu>a:hover{
    text-decoration: none;
  }

  .dropdown-submenu {
    position: relative;
  }

  .dropdown-submenu>.dropdown-menu {
    top: 0;
    left: 100%;
    margin-top: -6px;
    margin-left: -1px;
    -webkit-border-radius: 0 6px 6px 6px;
    -moz-border-radius: 0 6px 6px;
    border-radius: 0 6px 6px 6px;
  }

  .dropdown-submenu:hover>.dropdown-menu {
    display: block;
  }

  .dropdown-submenu>a:after {
  }

  .dropdown-submenu:hover>a:after {
    border-left-color: #fff;
  }

  .dropdown-submenu.pull-left {
    float: none;
  }

  .dropdown-submenu.pull-left>.dropdown-menu {
    left: -100%;
    margin-left: 10px;
    -webkit-border-radius: 6px 0 6px 6px;
    -moz-border-radius: 6px 0 6px 6px;
    border-radius: 6px 0 6px 6px;
  }

  a.dropdown-item {
    padding: 8px 24px;
  }

  a.dropdown-item:focus, a.dropdown-item:hover{
    background-color: #F5F7FC;
    color: #000;
  }

  a.dropdown-item.active {
    background-color: inherit;
    color: inherit;
  }

  a.dropdown-item.active:hover, a.dropdown-item.active:focus {
    background-color: #F5F7FC;
    color: #000;
  }

  #deleteCandidateDropdownItem {
    color: #d50057;
  }

  /**
   * Some bootstrap shims:
   */
  .radio label input {
    margin-top: 1px;
  }
  .checkbox label input {
    margin-top: 2px;
  }

  /*
   * React-bootstrap-table dropdown fixes
  */
  .action-dropdown {
    overflow: inherit !important;
  }
  .react-bs-container-body {
    overflow: inherit !important;
  }

  .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
    background-color: #78a8d8;
  }

  .jobs-landing-table>colgroup {
    border: hidden;
  }

  /**
   * The geosuggest module
   * NOTE: duplicated font-sizes' are for browsers which don't support rem (only IE 8)
   */
  .geosuggest {
    font-size: 18px;
    font-size: 1em;
    width: 100%;
    height: 100%;
    text-align: left;
  }
  .geosuggest__input {
    width: 100%;
    height: 100%;
    border: 1px solid grey;
    padding: .65em .65em;
  }
  .geosuggest__input:focus {
    border-color: #267dc0;
    box-shadow: 0 0 0 transparent;
  }
  .geosuggest__suggests {
    position: absolute;
    max-height: 25em;
    padding: 0;
    background: #fff;
    border: 2px solid #267dc0;
    border-top-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    list-style: none;
    z-index: 100;
  }
  /*.geosuggest_suggests:after {
    content: "";
    width: 30px;
    height: 30px;
    background: white url("./resources/images/powered_by_google_on_white.png") no-repeat -30px -50px fixed;
    top: 10px;
    right: 5px;
    position: absolute;
    display: inline-block;
  }*/

  .geosuggest__suggests--hidden {
    max-height: 0;
    overflow: hidden;
    border-width: 0;
  }

  #jobSearchBox div div div {
    position: absolute;
    z-index: 10;
    background-color: #FFF;
  }

  /**
   * A geosuggest item
   */
  .geosuggest__item {
    font-size: 18px;
    font-size: 1.25rem;
    padding: .5em .65em;
    cursor: pointer;
  }
  .geosuggest__item:hover,
  .geosuggest__item:focus {
    background: #f5f5f5;
  }
  .geosuggest__item--active {
    background: #267dc0;
    color: #fff;
  }
  .geosuggest__item--active:hover,
  .geosuggest__item--active:focus {
    background: #ccc;
  }
  .geosuggest__item__matched-text {
    font-weight: bold;
  }

  .defaultPanelContainer .panel-default {
    border: 1px solid rgba(0, 0, 0, 0.121569);
  }

  .modal-80w {
    width: 80%;
  }




  /**
   * NEW GLOBAL STYLES FOR UI KIT UPDATE - 7/19/2019
   */

  .page-header {
    color: #2AC6CD;
    font-family: Montserrat;
    font-size: 30px;
    font-weight: 500;
    margin: 15px 0;
    padding-top: 0;
  }

  h4 {
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }

  h5.text-header {
    font-family: Lato;
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
  }

  .btn-card-header {
    margin: 0;
    margin-top: -5px;
    margin-bottom: -10px;
    font-size: .6em;
  }

  .btn-card-table-header {
    margin: 15px 0px;
  }

  .btn-search-filter {
    height: 40px;
    border: 1px solid gray;
    border-radius: 5px;
    display: flex;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .search-filter-label-button {
    height: 28px;
    border-radius: 14px;
    background-color:#667995;
    color: white;
    padding-left: 10px;
    padding-right: 10px;
  }

  .search-results-close-icon {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  .search-filter-label-text {
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    padding-right: 5px;
  }

  .table-striped table tbody tr:nth-of-type(odd) {
    background-color: white;
  }

  .table-no-border td {
    border: 0;
  }

  .deactivate-user-modal .modal-content{
    width: fit-content;
  }

  .navbar-nav > .active {
    @media (max-width: 767px) {
      background-color: #eceef9;
    }
  }

  .navbar-nav > .active > span, .navbar-nav > .active a:not(.dropdown-item) {
    @media (min-width: 768px) {
      border-bottom: 3px solid #2dccd3;
      padding-bottom: 0;
    }
  }

  .navbar-expand-sm .navbar-nav .nav-link {
    @media (min-width: 768px) {
      padding-left: 0;
      padding-right: 0;
      margin-left: .5rem;
      margin-right: .5rem;
    }
  }

  .basic-nav-dropdown > .dropdown-menu {
    @media (max-width: 767px) {
      border: none;
    }
  }
  .basic-nav-dropdown > a.dropdown-toggle.nav-link::after {
    @media (max-width: 767px) {
      float: right;
      margin-right: 20px;
      margin-top: 10px;
    }
  }

  .basic-nav-dropdown.no-padding-sm > a.dropdown-toggle.nav-link::after {
    @media (max-width: 767px) {
      float: right;
      margin-right: 25px;
      margin-top: 10px;
    }
  }

  nav > div.navbar-collapse.collapse.show, nav > div.navbar-collapse.collapsing {
    @media (max-width: 767px) {
      background-color: white;
      padding-top: 10px;
      margin: 9px -9px -9px -9px;
    }
  }

  nav > div.navbar-collapse.collapse.show > .navbar-nav, nav > div.navbar-collapse.collapsing > .navbar-nav {
    @media (max-width: 767px) {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  .nav-link > span, .nav-item > .nav-link {
    @media (max-width: 767px) {
      color: black !important;
      padding-left: 20px;
    }
  }

  .navbar-nav .no-padding-sm.nav-item .nav-link {
    @media (max-width: 767px) {
      color: black !important;
      padding-left: 5px;
      font-size: 15px;
    }
  }

  .navbar-collapse.collapse.show {
    @media (max-width: 767px) {
      height: 100vh;
      z-index: 1002;
    }
  }

  @media only screen and (min-width: 769px) {
    .teams-link {
      display: none;
    }
  }

  .navbar-nav .post-hire-link.nav-link{
    padding-left: calc(8px + 1vw);
    border-left: 1px solid #4C6283;
  }

  .posthire-dropdown-link.locked,
  .post-hire-link.locked {
    color: #CCD2DC;
  }

  .teams-external-link-icon{
    margin-left: 5px;
    font-size: 16px;
    height: 14px;
  }

  .teams-external-link-icon.white{
    color: #CCD2DC;
  }

  @media only screen and (max-width: 767px) {
    .navbar-nav .post-hire-link.nav-link {
      margin: 10px 6px;
      padding: 0px;
      border-left: none;
    }
    .teams-external-link-icon{
      margin-left:auto;
      margin-right: 15px;
    }
    .teams-external-link-icon.white{
      color: #53565A;
    }
  }

  .beta-tag {
    border-radius: 4px;
    background-color: #C0EFF1;
    color: #125254;
    font-size: 12px;
    border: 1px solid #96E5E9;
  }

  .btn-cancel, .btn-cancel:active {
    border: none;
    margin-right: .25rem;
    font-weight: bold;
  }

  .btn-close-x {
    background-color: none;
    color: gray;
    border: 0;
    padding: 0;
    margin: 0;
  }

  .btn-close-x:hover, .btn-close-x:active {
    background-color: none;
    color: black;
  }

  .card-header button h6 {
    margin-bottom: 0;
  }

  .bulk-delete-modal-header {
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 0;
  }

  .modal-header h4 {
    margin-bottom: 0;
  }

  .header-empty-state {
    font-size: 24px;
    line-height: 36px;
    color: gray;
  }

  .card-header.card-aptitude {
    background-color: #ffe3b2;
    border-bottom: 3px solid #ffa300;
    padding: 5px 1.25rem;
  }

  .card-header.card-personality {
    background-color: #c0eff1;
    border-bottom: 3px solid #2dccd3;
    padding: 5px 1.25rem;
  }

  .card-header.card-emotional {
    background-color: #FFCEC3;
    border-bottom: 3px solid #FF5C39;
    padding: 5px 1.25rem;
  }

  .card-header.card-risk {
    background-color: #f2b2cc;
    border-bottom: 3px solid #D50057;
    padding: 5px 1.25rem;
  }

  .card-header.card-skills {
    background-color: #C6CEEE;
    border-bottom: 3px solid #425CC7;
    padding: 5px 1.25rem;
  }

  .card-header.card-testMakerTest, .card-header.card-TESTMAKER {
    background-color: #D3C8DF;
    border-bottom: 3px solid #9470B3;
    padding: 5px 1.25rem;
  }

  .test-title {
    font-weight: 600;
    padding: 0px;
    margin: 0px;
  }

  .test-type {
    font-size: 12px;
    font-weight: 500;
    padding-top: 0px;
    margin: 0px;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  .test-score-range {
    font-size: 10px;
    text-align: center;
    margin: 0px;
  }

  .btn-as-link {
    color: #425CC7;
    font-size: inherit;
    font-family: inherit;
    text-decoration: underline;
    background-color: transparent;
    border: none;
    padding: 0;
    position: relative;
    top: -1px
  }

  .btn-as-link:hover {
    background-color: transparent;
    color: darkBlue;
    text-decoration: none;
  }

  .modal .card-header-tabs {
    border-bottom: 1px solid #dee2e6;
  }

  .img-bordered {
    border: 1px solid gray;
    margin-bottom: 25px;
  }

  .badge-suggest-input {
    font-size: 12px;
    font-weight: normal;
  }

  .notValidatedCheckbox {
    margin-bottom: 0px;
  }

  .form-control-no-validate {
    border-color: black!important;
    background-image: none!important;
    box-shadow: none!important;
  }

  .buttonLinkStyle {
    color: blue;
    text-decoration: underline;
    background-color: none;
    border: none;
    padding: 0px;
  }

  .manual-override-invalid-feedback {
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .manual-override-warning-feedback {
    width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #ffa200;
  }

  .add-error-border {
    border-color: #dc3545!important;
  }

  .add-warning-border {
    border-color: #ffa200!important;
  }

  .overwrite-saved-button-style {
    font-size: 14px;
    font-weight: 500;
    font-family: Montserrat;
    color: black;
    margin-right: 25px;
    margin-bottom: 15px;
    border: 1px solid black;
    height: 35px;
    width: 150px;
  }

  .pipeline-card {
    min-width: 16%;
    max-width: 16%;
    margin-bottom: 15px!important;
    @media (max-width: 750px) {
      min-width: 26%;
      max-width: 26%;
    }
    @media (max-width: 575px) {
      min-width: 33%;
      max-width: 33%;
    }
  }

  .pipeline-card-item {
    text-align: center;
    margin-bottom: 8px;
  }

  #teamAccessJobsList {
    margin-top: 15px;
  }

  #jobsDropdown .dropdown-toggle:after { content: none }
  .modal-814w {
    max-width: 814px;
  }

  #copy_job_link.bottom .arrow:after {
    border-bottom-color: #1e469b;
  }

  #results_link.bottom .arrow:after {
    border-bottom-color: #1e469b;
  }

  .JobHeaderIcon:hover {
    background-color: #eceef9;
  }

  .rbc-btn-group button {
    font-size: 12px;
    text-transform: capitalize;
  }

  #bulk-actions {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  #bulk-actions .dropdown-submenu > a:after {
    display: none;
    border: 0;
  }

  .test-card-test-name {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    display: inline;
    padding: 5px;
    border-radius: 4px;
  }

  .test-card-scores div {
    height: 24px;
    padding-top: 2px;
    padding-right: 5px;
    font-size: 11px;
  }

  .test-card-score-name {
    font-size: 11px;
    width: 100%;
    text-overflow: ellipsis;
  }

  .test-card-illustrait-work-styles-only {
    font-size: 11px;
    width: 100%;
    text-overflow: ellipsis;
    font-weight: bold;
    color: #86888b;
  }

  .incomplete-scores, .incomplete-scores div {
    background-color: lightgray;
  }

  .candidate-profile-container .tab-content {
    border: none !important;
  }

  .candidateCardTable tbody tr td.incomplete-event {
    height: 24px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: transparent;
    background: repeating-linear-gradient(
      45deg,
      #b1b3b3,
      #b1b3b3 1px,
      #eff0f0 1px,
      #eff0f0 6px
    );
  }

  .title-bar {
    background-color: #FFF;
    border-bottom: 2px solid #D8D8D8;
  }

  .dashboard-redesign-toggle-bar {
    border-bottom: 1px solid #D9DEF4;
    background-color: #F5F7FC;
    padding: 12px 60px;
    justify-content: end;
    gap: 11px;
  }

  .dashboard-redesign-toggle-bar > span {
    margin-top: 1px;
    font-size: 13px;
  }

  .gray-beta-badge {
    font-size: 12px;
    margin-left: 8px;
    color: white;
    background-color: #667995;
    padding: 5px;
  }

  .analytics-title-bar {
    background-color: #f6f6f6;
  }

  /* Overwrite default bootstrap styles */

  .card h6.bg-dark {
    background-color: white !important;
  }

  .card h6.text-white {
    color: #1B4047 !important;
    font-size: 18px;
  }

  .card-header {
    border-bottom: none;
  }

  .card-header.bg-dark {
    padding-bottom: 0;
  }

  .btn-primary {
    background-color: #425cc7;
    border-color: #425cc7;
    font-weight: 500;
  }

  .btn-primary:hover {
    background-color: #546ccc;
    border-color: #546ccc;
  }

  .btn-primary:not(:disabled):not(.disabled):active {
    background-color: #2e408a;
    border-color: #2e408a;
  }

  .btn-primary:not(.no-shadow):focus {
    background-color: #425cc7;
    border: 1px solid #fff;
  }

  .btn-primary:disabled {
    background-color: #c6ceee;
    border-color: #c6ceee;
    font-weight: 500;
  }

  .btn-outline-primary {
    border-color: #425cc7;
    color: #425cc7;
  }

  .btn-outline-primary:disabled {
    border-color: #425cc7;
    color: #425cc7;
  }

  .btn-outline-primary:hover {
    background-color: #eceef9;
    border-color: #425cc7;
    color: #425cc7;
  }

  .btn-outline-primary:not(:disabled):not(.disabled).active,
  .btn-outline-primary:not(:disabled):not(.disabled):active,
  .show > .btn-outline-primary.dropdown-toggle {
    background-color:#d9def4;
    border-color: #425cc7;
    color: #425cc7;
  }

  .btn-outline-primary:active, .show > .btn-outline-primary.dropdown-toggle {
    background-color: #d9def4;
    border-color:#425cc7;
    color: #425cc7;
  }

  .btn-outline-secondary {
    background-color: white;
    border-color: #b1b3b3;
    color: #4d4d4f;
    font-weight: 500;
  }


  .btn-outline-secondary:hover {
    background-color: #f7f7f7;
    border-color: #b1b3b3;
    color: #4d4d4f;
    font-weight: 500;
  }

  .nav-pills .nav-link.active {
    background-color: #425cc7;
    border-color: #425cc7;
  }

  .table-active, .table-active>td, .table-active>th {
    background-color: #fff;
  }

  .badge-info {
    background-color: #d9def4;
    color: #425cc7;
  }

  .test-rectangle-card {
    padding: 0;
    margin: 0 5px 5px 0;
    width: 210px;
    float: left;
  }

  .test-rectangle-card_pending {
    border-left: 3px solid #667995;
  }

  .test-card-test-name {
    color: #4d4d4f;
    background-color: #c9c9ca;
  }

  .sticky-header {
    position: sticky;
    top: 0;
    z-index: 2;
  }

  #drag-image-moving-candidates {
    position: absolute;
    z-index: -2;
    background-color: #FFFFFF;
    padding: 10px;
    border-radius: 4px;
  }

  .simple-accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #D9D9D9;
    background-color: rgba(0,0,0,0);
  }

  .results-talentSignal-box {
    width: 45px;
    height: 34px;
    font-size: 16px;
    background: #001F4E;
    color: #FFFFFF;
    border-radius: 0px 0px 15px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }

  .results-talentSignal-box.overlayShowing {
    width: 30px;
    height: 16px;
    font-size: 14px;
    border-radius: 0px 0px 8px 0px;
  }

  .ieFlex {
    flex: 1 1 auto;
    justify-content: end;
  }

  .tab-with-background {
    background-color: white;
    border-left: 1px solid #D9DEE2;
    border-right: 1px solid #D9DEE2;
    border-bottom: 1px solid #D9DEE2;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .btn-light:not(:disabled):not(.disabled).active.toggle-button-dark,
  .btn-light:not(:disabled):not(.disabled).active.toggle-button-dark:hover,
  .toggle-button-dark,
  .toggle-button-dark:hover {
    border: 1px solid darkgrey;
  }

  /* ----------- Pagination Styles ----------- */

  .pagination a {
    color: #425cc7;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    font-weight: bold;
  }

  .pagination li.selected a {
    background-color: #425cc7;
    color: white;
    border-radius: 5px;
  }

  .pagination li:not(.selected) a:hover {
    background-color: #ddd;
    border-radius: 5px;
    cursor: pointer;
  }

  .pagination .previous-btn a span, .pagination .next-btn a span {
    color: '#425cc7';
  }

  .pagination li.disabled-btn a span {
    color: #b2bcca;
  }

  .pagination li.disabled-btn a:hover {
    background-color: white;
    cursor: auto;
  }

  .jobs-landing-page-table-header th {
    position: sticky;
    top: 0px;
    background-color: #FFF;
    box-shadow: 0 1px 0 0 #dee2e6;
    z-index: 998;
  }

  .react-table-header th {
    position: sticky;
    top: 0px;
    background-color: #FFF;
    z-index: 998;
  }

  .sticky-element:before,
  .sticky-element:after {
    content: '';
    display: table;
}

  .react-bootstrap-table-pagination {
    text-align: center;
  }

  /* ----------------------------------------- */

  #move_candidate_to_not_hired {
    border-radius: 0;
  }

  #more_actions {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .no-caret .dropdown-toggle::after,
  .no-caret .dropdown-toggle::before {
    display: none;
  }

  div.no-border button {
    border: 0;
  }

  .candidate-profile-tabs.card-header-tabs {
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    border-bottom: 1px solid #D9DEE2;
  }

  .job-title-header {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.36;
    color: #4d4d4f;
  }

  .page-sub-header {
    font-weight: 500;
    font-size: 24px;
  }

  .lead {
    font-size: 16px;
    line-height: 1.5;
  }

  .text-gray-70 {
    color: #828283;
  }

  #workStylesChart {
  background:
    linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 50%),
    linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 50%),
    radial-gradient(rgba(255, 255, 255, 0.8) 30%, rgba(255, 255, 255, 0)),
    linear-gradient(110deg, #d5f5f6 0%, rgba(255, 255, 255, 0) 100%),
    linear-gradient(70deg, #826AF0 0%, rgba(255, 255, 255, 0) 100%),
    linear-gradient(185deg, #FFA47E 0%, rgba(255, 255, 255, 0) 100%),
    linear-gradient(350deg, #F2D4ED 0%, rgba(255, 255, 255, 0) 100%);
}

  .accordion-one-element.accordion > .card:first-of-type {
    border-bottom: 1px solid #EAEAEA;
  }

  .no-display-mobile {
    @media (max-width: 575px) {
      display: none;
    }
  }
  .only-display-mobile {
    @media (min-width: 576px) {
      display: none;
    }
  }

  .noScrollMobile {
    @media (max-width: 575px) {
      overflow: hidden;
      position: fixed;
    }
  }

  .bg-blue-40 {
    background-color: #a5b5d3;
  }

  .bg-raspberry-20 {
    background-color: #f1cfdd;
  }

  .badge-clickable {
    cursor: pointer;
  }

  .badge-clickable:hover {
    background-color: #778fbd;
    color: white;
  }

  .modal-header-text {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.5;
  }

  .modal-body-text {
    font-size: 14px;
    line-height: 1.43
  }

  .modal-button-group {
    margin-top: 30px;
  }

  .modal-buttons {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
  }

  .bulk-action-modal-Buttons {
    background-color: #425cc7;
    font-size: 14px;
    font-weight: 500;
  }

  .modal-cancel-buttons {
    color: #425cc7;
    text-decoration: underline;
    background-color: none;
    border: none;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    margin-right: 20px;
  }
  .scrollable-modal-body{
    max-height: calc(100vh - 210px);
    overflow-y: auto;
  }

  .summary-nav-item{
    z-index:10;
  }
  .summary-nav-item > a, .nav-dropdown > a {
    color: #425cc7;
  }

  .summary-nav-item > a.active, .active-subnav {
    color: #425cc7 !important;
    font-weight: 500;
    border: none !important;
    border-bottom: 3px solid #2dccd3 !important;
  }

  .nav-dropdown > a {
    padding: 0px;
    margin-bottom: -2px;
    border-color: transparent !important;
  }

  .nav-dropdown > div.dropdown-menu {
    top: 9px !important;
    left: -16px !important;
  }

  .nav-dropdown.vi-nav-dropdown > div.dropdown-menu {
    min-width: 8.3rem !important;
  }

  .nav-dropdown.li-nav-dropdown > div.dropdown-menu {
    min-width: 7.5rem !important;
  }

  .summary-nav-link {
    padding: 8px 14px;
  }

  .interview-subnav {
    padding: 0;
  }

  .interview-subnav .nav-dropdown .nav-link {
    padding: 0.5rem 0.8rem;
  }

  .interview-subnav .dropdown-toggle.nav-link {
    background-color: transparent !important;
  }

  .interview-subnav .dropdown-menu.show {
    transform: translate3d(15px, 30px, 0px) !important;
  }

  .candidate-profile-tab-container {
    padding: 10px;
  }

  .candidate-profile-text-divider {
    color: #a9aaac;
    font-size: 18px;
    font-weight: normal;
  }

  .results-filter-score-range {
    transform: scale(1.75, 1.75);
  }

  .pending-events-header{
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    padding-bottom: 10px;
  }

  .pending-events-tab-pane {
    padding: 50px;
    padding-top: 25px;
  }

  .pending-events-header-row {
    border-bottom: solid 1px #e0e1e1;
  }

  .pending-event-testevent-row {
    padding: 10px 0px;
    border-bottom: solid 1px #e0e1e1;
  }

  .pending-events-eventid-text {
    font-weight: 500;
    line-height: 1.57;
    margin-bottom: 0px;
  }

  .pending-events-text {
    font-weight: normal;
    line-height: 1.43;
    margin-bottom: 0px;
  }

   .pending-events-test-card {
    margin-bottom: 0;
    min-height: 40px;
  }

  .pending-events-test-card tbody tr td {
    border: 0;
    vertical-align: middle;
    background-color: lightgray;
  }

  .email-template-preview {
    height: 300px;
    overflow: auto;
    width: 95%;
    font-size: 12px;
    color: #333;
    border: 1px solid #999;
    padding: 10px 0;
    > * {
      margin: 3px 2.5% 3px 2.5%;
    }
  }

  .remind-candidates-modal .dropdown-menu {
    max-height: 400px;
    overflow-y: auto;
  }

  .custom-modal-header {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000000;
  }

  .custom-modal-title {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
  }

  .custom-modal-text {
    font-size: 14px;
    line-height: 1.43;
  }

  #link-to-tests-container {
    background-color: #eceef9;
    padding: 16px;
  }

  .invite-modal-section-container {
    padding-left: 16px;
    padding-right: 16px;
  }

  .remove-baseline-button {
    background: none;
    color: lightBlue;
    font: inherit;
    text-decoration: underline;
    cursor: pointer;
    font-size: 12px;
  }

  #jobs-menu-slider-btn {
    height: 52px;
    width: 28px;
    border-top: 1px solid #979797;
    border-right: 1px solid #979797;
    border-bottom: 1px solid #979797;
    position: absolute;
    left: 0;
    top: 5px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .jobs-menu {
    width: 45vw;
    max-height: 100vh;
    overflow-y: auto;
    position: fixed;
    top: 58px;
    left: 0;
    background: #fff;
    transition: transform .5s cubic-bezier(0, .52, 0, 1);
    z-index: 4;
  }
  .make-transparent{
    opacity: 0;
  }
  .jobs-menu.hide {
    transform: translate3d(-50vw, 0, 0);
  }
  .jobs-menu.show {
    transform: translate3d(0vw, 0, 0);
  }
  .jobs-menu-title-bar {
    height: 56px;
    width: 103%;
    border-top: solid 1px #979797;
    border-right: solid 1px #979797;
    border-radius: 4px;
    background-color: #ffffff;
    z-index: 4;
    padding-left: 23px;
  }
  .jobs-menu-close-button {
    position: absolute;
    top: 20px;
    right: -20px;
    font-size: 16px;
  }
  .search-jobs-input {
    width: 85%;
    height: 32px;
    border-radius: 4px;
    margin-top: 12px;
    margin-left: 8px;
    border: solid 1px #b1b3b3;
    padding: 4px;
  }

  .slide-pane {
    display: flex;
    flex-direction: column;
    background: #fff;
    min-width: 100px;
    height: 100%;
    box-shadow: 0 8px 8px rgba(0,0,0,0.5);
    transition: transform 0.7s!important;
    will-change: transform;
  }
  .slide-pane:focus {
    outline-style: none;
  }
  .slide-pane_from_left {
    transform: translateX(-100%)!important;
  }
  .slide-pane_from_left.ReactModal__Content--after-open {
    transform: translateX(0%)!important;
  }
  .slide-pane_from_left.ReactModal__Content--before-close {
    transform: translateX(-100%)!important;
  }

  .slide-pane__overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(0,0,0,0);
    z-index: 11;
  }
  .slide-pane__overlay.ReactModal__Overlay--after-open {
    background-color: rgba(0,0,0,0.3);
    transition: background-color 0.5s;
    margin-top: 58px!important;
  }
  .slide-pane__overlay.ReactModal__Overlay--before-close {
    background-color: rgba(0,0,0,0);
  }

  .slide-pane__header {
    display: flex;
    flex: 0 0 64px;
    align-items: center;
    background: #ffffff;
    height: 64px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
    margin-bottom: 0px;
    width: 763px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .slide-pane__title-wrapper {
    display: flex;
    flex: 1;
    flex-direction: column;
    margin-left: 32px;
    min-width: 0;
  }
  .slide-pane .slide-pane__title {
    font-size: 18px;
    font-weight: normal;
    max-width: 80%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0;
    padding: 0;
  }
  .slide-pane__close {
    margin-left: 24px;
    padding: 16px;
    opacity: 0.7;
    position: absolute;
    right: -38px;
    cursor: pointer;
  }
  .slide-pane__content {
    position: relative;
    overflow-y: auto;
    padding: 0px 20px;
    flex: 1 1 auto;
  }

  .no-overflow {
    overflow: hidden;
  }

  .results-status-button-group {
    width: 90%;
    margin: auto;
  }

  .event-status-tabs {
    width: 90%;
    max-width: 500px;
    margin-left: 30px;
    padding-bottom: 8px;
  }

  .candidates-listing-search-input:focus {
    border-color: #ced4da;
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  #sort-candidates {
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .page-with-margin {
    margin-bottom: 20px;
  }

  /* Insight Progress Bar */

  .insight-progress-bar {
    padding-left: 0px;
  }

  .insight-progress-bar > li > span {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  .insight-progress-bar > li > span:first-child {
  width: 2em;
  height: 2em;
  font-size: 2.5rem;
  text-align: center;
  line-height: 2em;
  border-radius: 50%;
  background: #1d4591;
  margin: 0 1.5em;
  display: inline-block;
  color: white;
  position: relative;
  z-index: 1;
}

.insight-progress-bar > li > span:first-child:before {
  content: '';
  position: absolute;
  top: .9em;
  left: -3em;
  width: 3em;
  height: .2em;
  background: #1d4591;
}

.insight-progress-bar > li {
  list-style: none;
  display: inline-block;
}

.insight-progress-bar > .active ~ li > span::before {
  background: #dbdbdc;
}

.insight-progress-bar > li:first-child > span::before {
  display: none;
}

.insight-progress-bar > .active > li > span {
  background: #1d4591;
}

.insight-progress-bar > .active ~ li > span:first-child {
  background: #dbdbdc;
}

.insight-progress-bar > li > span:last-child {
  padding-top: 10px;
  margin: 0 auto;
  word-wrap: break-word;
  max-width: 60%;
  font-size: 1rem;
}


/* Insight Utility Styles */

/* Insight Job Function View */

.insight-radio-row > div {
  display: inline;
}

.insight-radio-row > div > input {
  margin-bottom: 50px;
}

.job-function-radio-form > .form-check-input {
  margin-top: 2px;
}

/* Insight Managerial Level View */

.managerial-level-radio-form > .form-check-input {
  margin-top: 2px;
}

/* Insight Job Function Info popovers */

#popover-basic {
  margin-left: 1rem;
  margin-bottom: 1rem;
  min-width: 250px;
}

#popover-basic > .arrow {
  margin-bottom: 0.5rem;
}

#popover-basic > .job-function-popover-title {
  background-color: #1d4591;
  color: #fff;
  text-align: center;
}

.job-function-list-items {
  font-size: 13px;
}

.job-function-list-items:first-child {
  margin-top: 5px;
}

.job-function-list-items:last-child {
  margin-bottom: 5px;
}

/* Insight English Requirement View */

.english-requirement-radio-form > .form-check-input {
  margin-top: 2px;
}

/* Insight Summary View*/

.insight-summary-error > .btn-as-link {
  top: 0px;
}

/* Insight Responsive */
@media only screen and (min-width: 320px) and (max-width: 479px){
  .insight-progress-bar li span:first-child {
    font-size: 1rem;
    margin: 0 0.5em;
  }

  .insight-progress-bar li span:last-child {
    display: none;
  }

  .insight-progress-bar li span:first-child:before {
    left: -1em;
    width: 1em;
    height: .25em;
  }

  .insight-progress-bar .active ~ li span::before {
    background: #dbdbdc;
  }
 }

@media only screen and (min-width: 480px) and (max-width: 767px){
  .insight-progress-bar li span:first-child {
    font-size: 1.5rem;
    margin: 0 1em;
  }

  .insight-progress-bar li span:last-child {
    font-size: 0.5rem;
  }

  .insight-progress-bar li span:first-child:before {
    left: -2em;
    width: 2em;
    height: .25em;
  }

  .insight-progress-bar .active ~ li span::before {
    background: #dbdbdc;
  }
 }

@media only screen and (min-width: 769px) and (max-width: 991px){
  .insight-progress-bar li span:first-child {
    font-size: 1.75rem;
    margin: 0 1.5em;
  }

  .insight-progress-bar li span:last-child {
    font-size: 0.65rem;
  }
 }

@media only screen and (min-width: 992px) {
  .insight-progress-bar li span:first-child {
    font-size: 2rem;
  }

  .insight-progress-bar li span:last-child {
    font-size: 0.8rem;
  }
 }
  .no-text-decoration {
    text-decoration: none;
  }

  /**********************************************************
   *
   *  Job Setup
   *
   **********************************************************/

  .job-search-bar {
    height: 40px;
    border-right: none;
    border-left: none;
    padding-left: 0px;
    font-size: 16px;
    background: transparent;
    border: none;
    color: black;
   }

   .job-search-bar-icons {
    background: transparent;
    border: none
   }

  .search-input {
    height: 40px;
    border: 1px solid #a9aaac;
    border-radius: 4px;
    font-size: 16px;
  }

  .clear-search-button {
   padding: 0px;
   border: none;
  }

  .clear-search-button:focus {
    box-shadow: none;
   }

  .clear-search-button:active {
    background-color: white!important
   }

  .search-button {
    height: 40px;
    font-size: bold;
    width: 114px;
    display: flex;
    justify-content: space-around;
  }

  .search-button:focus {
    box-shadow: none;
  }

  .search-button:active {
    background-color: white!important;
  }

  .search-button-text {
    color: #001f4e;
    margin: 1px 0 0 0;
    font-size: 16px;
    font-weight: bold;
  }

  .job-setup-tabs {
    background-color: #FFF;
    border: 1px solid #dee2e6;
    border-top: none;
  }

  #batteries-tab-recommendedBatteries{
    width: 50%;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0;
    text-align: center;
    height: 50px;
    font-weight: 300;
    color: #000000;
  }
  #batteries-tab-recommendedBatteries.active{
    font-weight: 500;
    border-top: solid 4px #425cc7;
  }

  #batteries-tab-customBatteries{
    width: 50%;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0;
    text-align: center;
    height: 50px;
    font-weight: 300;
    color: #000000;
  }
  #batteries-tab-customBatteries.active{
    font-weight: 500;
    border-top: solid 4px #425cc7;
  }

.test-battery-name, .structured-interviews-name {
    font-size: 20px;
    font-weight: bold;
    line-height: 1.5
  }

.structured-interviews-type {
    font-size: 16px;
    font-weight: bold;
    line-height: 1.5
  }

  .accordion-toggle {
    display: block;
    width: 100%;
    text-align: left;
  }

  .test-battery-label {
    color: #53565a;
    font-style: italic;
    font-size: 10px
  }

  .no-focus-visible-outline:focus:focus-visible {
    outline: none!important;
  }

  .no-focus-outline:focus {
    outline: none!important;
  }

  .total-time-text {
    font-size: 12px;
    line-height: 1.5;
    color: #4d4d4f;
  }

  .test-setup-test-box, .VI-setup-VI-box {
    max-width: 324px;
    min-width: 324px;
    margin-top: 10px;
  }

  .test-box-hover:hover {
    background-image: linear-gradient(to bottom, #001f4e, rgba(0, 0, 0, 0)30%, transparent 70%);
  }

  .test-box-footer {
    background-color: #FFF;
    border-top: 0;
  }

  .badge-list-badge {
    font-size: 12px;
    font-weight: bold;
    border-radius: 4px;
    padding: 4px;
    overflow-wrap: normal;
    display: inline-block;
    margin-bottom: 5px;
  }

  .test-box-hover:hover .badge-list-badge {
    opacity: 0.3;
  }

  .badge-list-badge::after {
    content: " ";
  }

  .aptitude-test-type-badge {
    background-color: #ffe3b2;
    color: #b37200;
  }

  .personality-test-type-badge {
    background-color: #c0eff1;
    color: #1f8f94;
  }

  .emotional-test-type-badge {
    background-color: #ffcec3;
    color: #7f2d1c;
  }

  .skills-test-type-badge {
    background-color: #c6ceee;
    color: #2e408a;
  }

  .testmaker-test-type-badge {
    background-color: #d0c0dd;
    color: #74429b;
  }

  .risk-test-type-badge {
    background-color: #f2b2cc;
    color: #6a002b;
  }

  .job-setup-description-text {
    font-size: 14px;
    font-style: italic;
    line-height: 1.43;
    padding-left: 0;
  }
  .card-body.job-setup-description-text{
    ${"" /* padding: 0px; */}
  }

  .score-range-box {
    background-color: #eff0f0;
    padding: 12px;
  }

  .score-range-header-text {
    font-size: 12px;
    font-weight: bold;
    color: #00c067;
    line-height: 1.5;
    letter-spacing: 1px;
  }

  .work-factors-box {
    background-color: #eaf9fa;
    padding: 12px;
  }

  .work-factors-header-text {
    font-size: 12px;
    font-weight: bold;
    color: #166669;
    line-height: 1.5;
    letter-spacing: 1px;
  }

  .competencyCard {
    border: 1px solid #a0ade3;
    background-color: #eceef9;
  }

  #job-setup-search-again-btn {
    border: solid 1px #425cc7;
    font-size: 14px;
    font-weight: 500
  }

  .related-jobs-accordion {
    border-radius: 0px;
    border-top: .5px solid #d8d9d9;
    border-left: none;
    border-right: none;
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .test-batteries-accordion {
    padding: 0px;
    margin: 0px 19px;
  }

  .emailTrackingTooltip > .tooltip-inner {
    background-color: #fff;
    color: #000;
    border: 1px solid #425cc7;
    font-size: 0.8rem;
    padding: 10px;
  }

  .emailTrackingTooltip > .arrow::before {
    border-top-color: #425cc7;
  }

  .beta-badge {
    font-size: 12px;
    height: 16px;
    margin-left: 10px;
    background-color: #2dccd3;
    color: #FFFFFF;
  }

.new-badge {
    font-size: 12px;
    height: 18px;
    width: 38px;
    margin-left: 10px;
    background-color: #2dccd3;
    color: #FFFFFF;
  }

  #workplace-insights-tooltip > .tooltip-inner {
    max-width: none;
    width: 333px;
    padding: 13px 12px;
    min-width: 24px;
    height: 100%;
    font-size: 12px;
    line-height: 18px;
    color: black;
    text-align: center;
    text-decoration: none;
    background-color: #FFF;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }
  #workplace-insights-tooltip > .arrow::before {
    border-top-color: transparent;
  }

  .workplace-insights-toggle.react-toggle--checked .react-toggle-track {
    background-color:  #2dccd3;
  }

  #insightsReport #header {
    padding: 0 16px;
  }

  .settings-sub-header {
    font-size: 50px;
    font-weight: 500;
    line-height: 1.6;
  }

  .no-tests-in-battery-settings {
    font-size: 16px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    margin-bottom: 0px;
    margin-top: 8px;
  }

  .evaluation-badge {
    border-radius: 4px;
    height: 24px;
    margin-top: 10px;
    padding: 3px 4px;
    font-size: 12px;
    font-weight: bold;
    background-color: #b3bee9;
    color: #425cc7;
    width: 95px;
  }

  .SI-badge {
    background-color: #b2e5f5;
    color: #005470;
    width: fit-content;
  }

  .evaluation-card {
    width: 320px;
    height: 284px;
    margin-bottom: 5px;
    background-color: #fff;
    cursor: pointer;
  }

  .evaluation-card-header {
    background-color: #fff;
    position: relative;
    overflow: hidden;
  }

  .evaluation-card:hover:not(.evaluation-card-locked) > .evaluation-card-header, .evaluation-card-selected:not(.evaluation-card-locked) > .evaluation-card-header {
    background-color: #f5f7fc !important;
  }

  .evaluation-card:hover:not(.evaluation-card-locked):not(.evaluation-card-selected) {
    border: solid 1px #425cc7;
    background-color: #f5f7fc !important;
  }

  .evaluation-card-selected {
    outline: solid 2px #425cc7;
    background-color: #f5f7fc !important;
  }

  .evaluation-card-button {
    height: 20px;
    width: 20px;
    margin: 8px 15px 0 0;
    padding: 0px;
    border: solid 1px #64666a;
    border-radius: 50%;
    background-color: transparent!important;
    box-shadow: none!important;
  }

  .evaluation-card-button:focus {
    border: solid 1px #64666a;
    background-color: #fae5ee;
  }

  .evaluation-card-error {
    border: solid 1px #d50057!important;
    background-color: #fae5ee!important;
  }

  .evaluation-card-tip-text {
    color: #53565a;
    font-size: 12px;
    width: 320px;
    line-height: 1.67
  }

  .job-title-input input {
    min-height: 40px;
  }

  .evaluation-text {
    width: 284px;
    height: 80px;
    font-size: 14px;
    background-color: transparent;
  }

  .job-creation-VI-dropdown {
    .Select-control {
      width: 50%;
      border-color: #a9aaac;
      height: 32px;
      color: black;
      margin-bottom: 16px;
    }

    &.full-width {
      .dropdown-toggle, .dropdown-menu {
        width: 100%;
      }
    }

    .dropdown-toggle {
      width: 50%;
      border-color: #a9aaac;
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      text-overflow: ellipsis !important;
      &::after {
        color: black;
      }

      span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .dropdown-toggle#structuredInterviewType {
      min-width: 100% !important;
    }
    .dropdown-menu {
      width: 50%;
      max-height: 400px;
      overflow-y: auto;
      .dropdown-item {
        white-space: normal;
      }
    }
    .Select-arrow {
      border-color: black transparent transparent;
      border-width: 4px 4px 2.5px
    }
  }

  .regular-VI-dropdown {
    .dropdown-menu {
      width: 50%;
      max-height: 400px;
      overflow-y: auto;

      .dropdown-item {
        white-space: normal;
      }
    }
  }

  .VI-lower-line {
    position: absolute;
    left: 0;
    right: 0;
    margin-top: 2.2rem;
  }

  .evaluator-number-dropdown > .dropdown-toggle {
    width: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &::after {
        color: black;
      }
  }

  .evaluator-number-dropdown-error > .dropdown-toggle {
    border: 1px solid #d50057
  }

  .choose-evaluation-text {
    margin-bottom: 30px;
  }

  .evaluation-tools-warning {
    display: flex;
    align-items: center;
    background-color: #fae5ee;
    border: solid 1px #f7ccdd;
    height: 52px;
    padding: 16px;
    border-radius: 4px;
    color: #94003c;
    margin: 30px 0 -20px 0
  }

  .evaluation-caution-sign {
    width: 16px;
    height: 16px;
    margin-right: 16px;
  }

  .evaluation-banner-sign {
    width: 16px;
    height: 16px;
    margin-right: 16px;
    margin-bottom: 2px;
  }

  .evaluation-tools-info-banner {
    display: flex;
    align-items: center;
    background-color: #eaf9fa;
    border: solid 1px #d5f5f6;
    height: 52px;
    padding: 16px;
    border-radius: 4px;
    color: #166669;
    margin: 16px 0;
  }

  .show-more-button {
    background-color: white;
    color: #425cc7;
    margin: 0 10px;
    border: none;
    font-size: 14px;
    font-weight: bold;
    padding: 0px;
    height: 20px;
  }

  .show-more-button:active {
    background-color: white!important;
    color: #425cc7!important;
  }

  .show-more-button:focus {
    box-shadow: none!important;
    border: none!important;
  }

  .show-more-button:hover {
    background-color: white;
    color: #425cc7;
  }

  .copy-link-button {
    border-radius: 4px!important;
    font-size: 14px!important;
    height: 40px;
    flex-basis: 100px;
    display: flex;
    justify-content: between;
    align-items: center;
    gap: 16px;
  }

  .new-job-modal {
    display: flex;
    justify-content: center;
  }

  .new-job-modal .modal-content {
    max-width: 885px;
  }

  .test-link-button {
    text-decoration: underline;
    font-size: 13px!important;
    margin-bottom: 9px;
    border-radius: 4px!important;
    max-width: 600px;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 40px;
    padding: 8px;
  }

  .progress-bar-container {
    border: none;
    display: flex;
    align-items: center;
    background-color: #FFF;
  }

  .grey-progress-bar {
    background-color: #F6F6F6;;
  }

  .progress-bar-number {
    background-color: #425cc7;
    height: 20px;
    width: 20px;
    border-radius: 50%;
    margin-right: 88px;
    display: flex;
    justify-content: center
  }

  .blue-bar {
    width: 75px;
    height: 2px;
    background-color: #546ccc;
    padding-left: 40px;
  }

  .grey-bar {
    background-color: #d9d9d9
  }

  .padding-no-VI {
    padding-right: 80px
  }

  .padding-last-tool > * {
    padding-right: 80px
  }

  .grey-number {
    background-color: #edeeee;
    border: solid 1px #cbcccd;
  }

  .grey-text {
    color: #cbcccd;
  }

  /* ---------- Delete Score Range Modal ---------*/

  .delete-score-range-modal-header {
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 0;
  }

  .delete-score-range-modal-footer {
    border: hidden;
    text-align: right;
    margin-top: -20px;
  }


  /* ---------- Create Score Range ---------*/

  .more-info-btn {
    border: none;
    padding: 0;
  }

  .distribution-table {
    height: 125px;
  }

  .distribution-cell {
    vertical-align: bottom;
    height: 100%;
    padding: 0 1px 0 0;
    float: left;
    margin-top: 0;
    margin-bottom: 0;
  }

  .distribution-cell div {
    width: 100%;
  }

  .distribution-cell-black-line {
    border-left: 1px solid black;
    position: relative;
  }

  .distribution-cell-black-line:hover {
    border-left: 4px solid #007aff;
  }

  td.distribution-score-range-cell{
    position: relative;
    vertical-align: bottom;
    border: 0;
    padding: 20px 1px 0px;
  }

  .distribution-cell-in-range:before {
    content:'';
    display: block;
    top: 0;
    position:absolute;
    height: 100%;
    width: 100%;
    z-index: 10;
    background-color: rgba(0, 31, 78, 0.15);
  }

  .distribution-cell-in-range-last:before {
    width:calc(100% - 2px)
  }

  .distribution-cell-in-range-first:after {
    content: attr(rangetitle);
    top: 0;
    position:absolute;
    z-index: 10;
    width: var(--range-width);
    margin-top: 8px;
    margin-left: 12px;
    font-size: 11px;
    font-weight:bold;
  }


  /* ---------- Test Tags ---------- */

  .test-tag {
    font-family: Lato;
    font-size: 12px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 1.2px;
  }

  .aptitude-test-tag {
    color: #b37200;
    background-color: #ffe3b2;
  }

  .personality-test-tag {
    color: #1f8f94;
    background-color: #c0eff1;
  }

  .emotional-test-tag {
    color: #7f2d1c;
    background-color: #ffcec3;
  }

  .skills-test-tag {
    color: #2e408a;
    background-color: #c6ceee;
  }

  .testmaker-test-tag {
    color: #4d4d4f;
    background-color: #c9c9ca;
  }

  .risk-test-tag {
    background-color: #f2b2cc;
    color: #6a002b;
  }

  .video-interview-tag {
    background-color: #b2e5f5;
    color: #005470
  }

  .proctoring-tag {
    color: #fff;
    background-color: #334C71;
  }

  .proctoring-passed-badge {
    padding: 3px 4px;
    border-radius: 2px;
    font-size: 13px;
    text-align: center;
    background-color: var(--navy-20);
    color: var(--navy-100);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1px;
    margin-top: 2px;
    line-height: 22px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  /* ---------- Default Badge ---------- */

  .default-badge {
    font-family: Lato;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    background-color: #2dccd3;
    padding: 3px 6px;
  }

  /* ---------- Manage Score Range Table ---------- */

  .score-range-landing-table .table {
    margin-bottom: 0px;
  }

  .score-range-table-header {
    font-size: 20px;
  }

  .score-range-table-cells {
    font-size: 14px;
    line-height: 1.43%;
  }

  /* ---------- Create User Modal ---------- */

  .email-text-field-error .MuiFormHelperText-root {
    font-size: .64rem;
    font-family: Lato,'Helvetica Neue',Helvetica,Arial,sans-serif;
  }

  .email-text-field-error .MuiFormHelperText-contained {
    margin-left: 1px;
  }

  .email-text-field-error .MuiFormHelperText-root.Mui-error {
    color: #dc3545;
  }

  .email-text-field-error .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: #dc3545;
  }

  /* ---------- Associated Jobs Modal ---------- */

  /* TODO: make a modal header class to apply to all of hireselect */

  .associated-jobs-modal-header {
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 0;
  }

  .associated-jobs-modal > .modal-content {
    overflow: hidden;
    height: 776px;
    max-height: 776px;
  }

  .associated-jobs-modal-body {
    padding-bottom: 0px;
    padding-right: 0px;
    padding-left: 0px;
  }

  .associated-jobs-modal-body > .form-group {
    padding-right: 16px;
    padding-left: 16px;
  }

  .list-group-item {
    padding: 5px;
    background-color: #F2F3F6;
    border: none;
  }

  .insightManagerialLevelForm .list-group-item {
    padding: 12px 20px;
    background-color: #FFF;
    border: 1px solid #DFDFDF;
  }

  .associated-jobs-list-group {
    max-height: 720px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 16px;
    padding-left: 16px;
  }

  .job-title-search-icon {
    background: #ffffff;
    border: none;
    margin-right: 5px;
    padding-left: 5px;
  }

  .job-title-search-input {
    border-radius: .25rem !important;
  }

  .job-title-search-modal-divider {
    margin-bottom: 0px;
  }

  .associated-job-title {
    font-size: 14px;
  }

  .associated-job-description {
    font-size: 12px;
  }

  .associated-jobs-list-item, .yield-jobs-list-item {
    background-color: #ffffff;
    margin-bottom: 0px;
  }

  .associated-jobs-list-item > hr {
    margin-bottom: 0px;
    margin-left: -21px;
    margin-right: -21px;
  }

  .associated-jobs-list-item:last-child > hr {
    display: none;
  }

  .associated-jobs-list-item:first-child {
    padding-top: 16px;
  }

  .associated-jobs-list-item:last-child {
    padding-bottom: 16px;
  }

  /* ---------- Set Notifications Jobs Modal ---------- */

  .set-notifications-modal-header {
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #000000;
    margin-top: 0;
  }

  .set-notifications-modal > .modal-dialog{
    width: 700px;
    max-width: 700px;
  }

  .set-notifications-modal-body {
    max-height: 658px;
    overflow-y: auto;
  }

  .set-notifications-modal-body > .form-group {
    padding-right: 16px;
    padding-left: 16px;
  }

  .set-all-notifications-form {
    padding-top: 6px;
    height: 29px;
  }

  .set-all-notifications {
    margin-bottom: 0px;
    height: 30px;
    overflow: auto;
  }

  .all-notifications-dropdown {
    margin-left: 11px;
  }

  .set-job-notification {
    height: 50px;
    width: 652px;
    margin-left: -13px;
    border-bottom: 1px solid #DFDFDF;
    padding: 0 19px 0 11px;
  }

  .set-job-notification > * {
    text-align: center;
    margin: 0px;
    margin-bottom: auto;
    margin-top: auto;
    padding-left: 8px;
  }

  .notifications-dropdown-button {
    height: 32px;
    width: 229px;
    padding: 6px;
    text-align: left;
    display: flex;
    flex-direction: column;
    align-content: space-between;
    flex-wrap: wrap;
    justify-content: center;
  }

  .dropdown-label {
    width: 30px;
  }

  .bell-icon {
    margin-right: 8px;
    margin-left: 3px;
  }

  .bell-icon-my {
    margin-right: 7px;
    margin-left: 3px;
  }


  .notifications-job-text {
    font-size: 14px;
    margin-bottom: 0px;
    font-weight: bold;
    text-align: left;
    width: 190px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .notifications-jobid-text {
    font-size: 14px;
    margin-bottom: 0px;
    text-align: left;
  }

  .back-button {
    color: #425cc7;
    justify-self: left;
  }

  img.icon-16px-arrowLeft {
    width: 16px;
    height: 16px;
    margin: 4px 8px 4px 0;
    object-fit: contain;
  }

  .space-around {
    display: flex;
    justify-content: space-between;
  }

  .all-notifications-card-body {
    padding: 11px 1.5rem;
    height: 56px
  }

  .checked-jobs-container {
    overflow: scroll;
    border-radius: 0;
    margin-top: 1.25rem;
    width: 652px;
    margin-left: 6px;
  }

  .unchecked-jobs-container {
    border: none;
  }

  .checked-card-body {
    padding-top: 0;
    padding-left: 13px;
    max-height: 468px;
  }

   ${
     "" /* /* .list-group-item {
    padding: 5px;
    background-color: #F2F3F6;
    border: none;
  } */
   }

  /* ---------- Score Range Filter Results ---------- */

  .score-range-by-position > .dropdown-menu, .add-video-interview-modal .dropdown-menu {
    max-height: 300px;
    overflow-y: auto;
  }

  /* ---------- Select Jobs Score Ranges ---------- */

  .yield-jobs-modal-body {
    max-height: 720px;
    overflow-y: auto;
    overflow-x: hidden;
    margin-left: 15px;
  }

  /* ---------- Candidate Yield Warning Popover ---------- */

  #popover_200_candidates_warning {
    border-color: #b1b3b3;
  }

  #popover_200_candidates_warning > .arrow:before {
    border-top-color: #b1b3b3;
  }

  #popover_200_candidates_warning > .arrow {
    border-bottom-color: #b1b3b3;
  }

  .select-css {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #4D4D4F;
    line-height: 1.3;
    padding: 4px 8px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin: 0;
    border: 1px solid #B1B3B3;
    box-shadow: 0 1px 0 1px rgba(0,0,0,.04);
    border-radius: 3.2px;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%234D4D4F%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E');
    background-repeat: no-repeat, repeat;
    background-position: right .7em top 50%, 0 0;
    background-size: .65em auto, 100%;
  }
  .select-css::-ms-expand {
    display: none;
  }
  .select-css:hover {
    border-color: #888;
  }
  .select-css:focus {
    border-color: #aaa;
    box-shadow: 0 0 1px 3px rgba(59, 153, 252, .7);
    box-shadow: 0 0 0 3px -moz-mac-focusring;
    color: #222;
    outline: none;
  }
  .select-css option {
    font-weight:normal;
  }

  .linesWithMiddleText {
    overflow: hidden;
    text-align: center;
  }
  .linesWithMiddleText:before,
  .linesWithMiddleText:after {
    background-color: #c8cad2;;
    content: "";
    display: inline-block;
    height: 1px;
    position: relative;
    vertical-align: middle;
    width: 50%;
  }

  .linesWithMiddleText:before {
    right: 0.5em;
    margin-left: -50%;
  }

  .linesWithMiddleText:after {
    left: 0.5em;
    margin-right: -50%;
  }
  /* ---------- Table Filters ---------- */

  .table-search-icon {
    background: #ffffff;
    color: #939598;
  }

  .jobs-landing-page > tbody{
    overflow-y: auto
  }

  #bulk-edit-button {
    width: 90%;
  }

  #bulk-notifications-button {
    width: 90%;
    min-height: 32px;
    border-radius: 4px;
    border: solid 1px var(--bright-gray-100);
  }

  /* ---------- Partners  ---------- */

  .formControlSelect.is-invalid {
    background-image: none !important;
  }

  .formControlSelect.is-valid {
    background-image: none !important;
  }

  /* ---------- Partners NavBar ---------- */

  .partners-profile-dropdown > .dropdown-toggle:after {
    content: none;
  }

  /* ---------- Company Preferences ---------- */

  .react-toggle.react-toggle--checked .react-toggle-track {
    background-color:  #2dccd3;
  }

  .react-toggle.react-toggle--checked .react-toggle-thumb {
    border-color:  #2dccd3;
  }

  .react-toggle.react-toggle--checked:hover .react-toggle-track {
    background-color:  #26ADB3 !important;
  }

  .react-toggle:not(.react-toggle--checked) .react-toggle-track {
    background-color:  #B1B3B3;
  }

  .react-toggle:not(.react-toggle--checked) .react-toggle-thumb {
    border-color:  #B1B3B3;
  }

  .react-toggle:not(.react-toggle--checked):hover .react-toggle-track {
    background-color:  #969898 !important;
  }

  .new-badge {
    background-color: #2dccd3;
    color: #ffffff;
    font-size: 12px;
    padding: 3px 6px;
  }

  .customerSuccessManagerModal > .modal-dialog {
    max-width: 600px;
  }

  /* ---------- Invitation Settings ---------- */

  .notifications-info-box {
    border: solid 1px #d9dadb;
    border-radius: 5px;
    border-left: solid 4px #425cc7;
    background-color: #f8f9fa;
  }

  .assessmentModeTooltip > .tooltip-inner {
    max-width: none;
    width: 333px;
    padding: 13px 12px;
    min-width: 24px;
    height: 100%;
    font-size: 12px;
    line-height: 18px;
    color: black;
    text-align: center;
    text-decoration: none;
    background-color: #FFF;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }

  .assessmentModeTooltip > .arrow::before {
    border-right-color: transparent;
  }

  /* ---------- Invite Specific Candidates Page ---------- */

  #scheduleTest:disabled {
    background-color: #425cc7;
    border-color: #425cc7;
    opacity: .65;
  }

  .candidateSchedulingModal > .modal-dialog,
  .candidateInvitingModal > .modal-dialog {
    max-width: 600px;
  }

  .advancedSettingsGrayInputRow {
    padding: 16px;
    margin: 16px 0 8px 0;
    display: flex;
    justify-content: space-between;
    background-color: #f7f7f7;
  }

  /* ---------- Invite Specific Candidates Page: Job Info ---------- */

  .testBatteryInfoBox, .videoInterviewInfoCard {
    background-color: #fff;
    border: solid 1px #d9dadb;
    border-radius: 4px;
    padding: 15px 0px;
  }

  .testBatteryInfoCardsContainer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  /* ---------- Invite Specific Candidates Page: Add Candidate Form ---------- */

  .scheduledCandidatesTable {
    margin-bottom: 0px;
  }

  .scheduledCandidatesTable > tbody > tr:first-of-type {
    border-top: 2px solid #d8d9d9 !important;
  }

  .add-candidate-CSV-modal > .modal-dialog {
    max-width: 600px;
  }

  #uploadCSVFile {
    background-color: #fff;
    color: #425cc7;
    font-weight: bold;
    border: none;
  }

  .addCandidateFormGroup {
    flex: 1 1 0 !important;
  }

  .addCandidateFormInput.form-control.is-invalid, .was-validated .form-control:invalid {
    background-image: none;
    padding-right: 12px;
  }

  .addCandidateFormInput.form-control.is-valid, .was-validated .form-control:valid {
    background-image: none;
    padding-right: 12px;
  }

  #scheduleAddCandidate, .addCandidateFormGroup {
    align-self: flex-start;
  }

  /* ---------- Invite Specific Candidate Page: Test Event Expiration ---------- */

  .eventExpirationCheckboxGroup .custom-control-label {
    line-height: 24px !important;
  }

  .eventExpirationDaysSelect .Select-menu-outer {
    width: 150px !important;
  }

  /* ---------- Send Test Invitation ---------- */

  #individualTestOptions {
    width: 100%;
    font-size: 16px;
  }

  #individualTestOptions::after {
    margin-left: 8px;
    color: #86888b;
  }

  #selectBatteryTab > a {
    color: '#425cc7';
  }

  /* ---------- Login Page ---------- */

  .loginLeftPanel {
    height: 100vh;
    text-align: center;
    background: transparent url("https://s3.amazonaws.com/criteria-static-web-assets/logon/na-login-left-panel.png") -5px -5px repeat;
  }

  .loginLeftPanel.au {
    background: transparent url("https://s3.amazonaws.com/criteria-static-web-assets/logon/apac-login-left-panel.png") -5px -5px repeat;
  }

  .loginLeftPanel table {
    height: 100vh;
    width: 100%;
  }

  .loginRightPanel {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100vh;
    padding: 0 25px 48px 25px;
    background-color: white;
  }

  .loginPageFooter {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    text-align: center;
    color: #53565A;
    padding: 0 48px;
  }

  .loginPageFooter .copyright, .loginPageFooter a {
    cursor: pointer;
    color: #425CC7;
    text-decoration: underline;
  }

  .tryForFreeButton {
    color: #4d4d4f;
    background-color: white;
    border: 1px solid #b1b3b3;
    border-radius: 3px;
    padding: 6px 12px;
    margin-left: 4px;
  }

  .criteria-logo-small {
    margin: 18px 0 0 8px;
  }

  .logged-out-modal .modal-content {
    height: 400px;
    width: 600px;
  }
  .logged-out-modal .modal-body {
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-top:60px;
  }
  .logged-out-modal h1{
    font-size: 24px;
    font-weight:bold;
    padding-top: 5px;
  }
  .logged-out-modal p{
    font-size: 16px;
  }
  .logged-out-modal button{
    display:block;
    width: 288px;
    height:40px;
  }

  .teaming-button {
    height: 32px;
    margin: auto;
  }

  .teaming-button:hover {
    background-color: #001f4e;
    color: #FFF;
  }

  .teaming-badge {
    font-family: Lato;
    font-size: 10px;
    font-weight: bold;
    line-height: 1;
    text-align: center;
    color: #FFF;
    background-color: #667995;
    border-radius: 4px;
  }

  .MuiAutocomplete-inputRoot {
    height: calc(1.5em + .75rem + 2px)!important;
    padding-top: 0px!important;
    font-size: 13px!important;
    font-family: Lato!important;
  }

  .MuiAutocomplete-option {
    border-bottom: 1px solid #d8d9d9!important;
  }

  .dropdown-text {
    font-family: Lato!important;
    font-size: 14px!important;
    font-weight: bold!important;
    line-height: 1.43!important;
    color: #001f4e!important;
  }

  .dropdown-text-muted {
    font-family: Lato!important;
    font-size: 12px!important;
    line-height: 1.5!important;
    color: #7f7f7f!important;
  }

  /* ---------- Login Page Country Dropdown ---------- */

  #countryDropdownToggle::after {
    position: absolute;
    right: 20px;
    top: 45%;
    border-top: .3em solid #b1b3b3;
  }

  #countryDropdownContinueBtn {
    margin-bottom: 40px;
  }

  /* ---------- Pipeline Automation ---------- */

  .emailTestLinkTestBatteriesDropdown > .dropdown-toggle {
    color: #86888b;
  }

  /* ---------- AU Job Setup ---------- */

  #auJobSetupRadioBtn > .form-check-input {
    margin-bottom: 4px;
  }

  #applicationDropdownToggle::after {
    position: absolute;
    right: 15%;
    top: 45%;
    border-top: .3em solid #b1b3b3;
  }

  .pipelineArrow {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 10px 16px 0 16px;
    border-color: #d8d8d8 transparent transparent transparent;
    position: relative;
  }

  .pipelineArrow::before {
    content: "";
    position: absolute;
    height: 10px;
    width: 16px;
    bottom: 6px;
    right: -8px;
    background-color: #d8d8d8;
  }

  .selectPipelineWithoutApplication {
    border: 1px solid #dfdfdf;
    border-radius: 4px 4px 0px 0px;
    border-bottom: none
  }

  .selectedTemplatePipeline.selectPipelineWithoutApplication {
    border-color: #425cc7;
    background-color: #f5f7fc
  }

  .selectedTemplatePipeline.selectPipelineWithoutApplication ~ .selectPipelineWithApplication {
    border-top-color: #425cc7;
  }

  .selectedTemplatePipeline.selectPipelineWithApplication {
    border-color: #425cc7;
    background-color: #f5f7fc
  }

  .selectPipelineWithApplication {
    border: 1px solid #dfdfdf;
    border-radius: 0px 0px 4px 4px;
  }

  .selectCustomPipeline {
    border: 1px solid #dfdfdf;
    border-radius: 4px 4px 0px 0px;
    border-bottom: none
  }

  .selectCustomPipeline:nth-last-child(1) {
    border-bottom: 1px solid #dfdfdf;
    border-radius: 0px 0px 4px 4px;
  }

  .selectCustomPipeline ~ .selectCustomPipeline {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }

  .customPipelineSelected.selectCustomPipeline {
    border-color: #425cc7;
    background-color: #f5f7fc
  }

  .customPipelineSelected.selectCustomPipeline + .selectCustomPipeline {
    border-top-color: #425cc7;
  }

  .remove-application-incoming-check label {
    color: #e11f3b
  }

  .pipeline-stage-to-assign-testing > .form-check-input {
    margin-top: 2px;
  }

  .remove-application-incoming-check > .form-check-input {
    margin-top: 2px;
  }

  #criteriaTestList .dropdown-item {
    padding-left: 45px;
  }

  .updateTestBatteryAlertOverflow {
    height: 16px;
    width: 16px;
    background-color: #ffa300;
    border-radius: 50%;
    color: #fff;
    position: absolute;
    bottom: 60%;
    left: 70%;
    font-size: 10px;
    z-index: 5;
  }

  .updateTestBatteryDropdownItemAlert {
    height: 16px;
    width: 16px;
    background-color: #ffa300;
    border-radius: 50%;
    color: #fff;
    display: inline-block;
    margin-bottom: 2px;
    vertical-align: middle;
    font-size: 10px;
  }

  .updateTestBatteryModal > .modal-dialog, .confirmNewTestBatteryModal > .modal-dialog {
    max-width: 600px;
  }

  #updateNowTestBatteryBtn, #keepTestBatteryBtn {
    margin-top: 2px !important;
  }

  .newCriteriaBatteryNotification {
    position: fixed;
    bottom: 10px;
    left: 15px;
    width: 430px;
    height: 195px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
    z-index: 1000;
    border-left: 4px solid #2dccd3;
  }

  .invalidFormFeedback {
    color: #D50057;
    font-size: 12px;
  }

  .modalBtnCancel {
    color: #425cc7;
    font-weight: bold;
  }

  .modalBtnCancel:hover {
    color: #425cc7;
  }

  .loading{
    cursor: wait;
  }

  .updateTestBatteryAlertOverflow {
    height: 16px;
    width: 16px;
    background-color: #ffa300;
    border-radius: 50%;
    color: #fff;
    position: absolute;
    bottom: 60%;
    left: 70%;
    font-size: 10px;
    z-index: 5;
  }

  .updateTestBatteryDropdownItemAlert {
    height: 16px;
    width: 16px;
    background-color: #ffa300;
    border-radius: 50%;
    color: #fff;
    display: inline-block;
    margin-bottom: 2px;
    text-align: center;
    vertical-align: middle;
    font-size: 10px;
  }

  .updateTestBatteryModal > .modal-dialog, .confirmNewTestBatteryModal > .modal-dialog {
    max-width: 600px;
  }

  #updateNowTestBatteryBtn, #keepTestBatteryBtn {
    margin-top: 2px !important;
  }

  .newCriteriaBatteryNotification {
    position: fixed;
    bottom: 10px;
    left: 15px;
    width: 430px;
    height: 195px;
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
    z-index: 1000;
  }

  .talent-insights-cta-container {
    padding: 25px;
    border-radius: 4px;
    border: solid 1px #2dccd3;
    background-color: #fff;
  }

  .develop-cta-container {
    display: flex;
    justify-content: center;
    background-color: #F5F7FC;
    padding: 24px;
  }

  .talent-insights-cta-header {
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    text-align: left;
    color: #001f4e;
    margin-bottom: 0px;
  }
   .teal-button {
    /* width: 202px; */
    padding-left: 25px;
    padding-right: 25px;
    height: 40px;
    border-radius: 4px;
    background-color: #2dccd3;
    font-family: Lato;
    font-size: 14px;
    font-weight: bold;
    line-height: 1.43;
    color: #ffffff;
    border: none;
  }

  .teal-button:hover {
    background-color: #42d1d7;
  }

  .teal-button:active {
    background-color: #1f8e93;
  }

  .teal-button:focus {
    border: 1px solid #fff;
    box-shadow: 0 0 0 .2rem #2dccd3;
  }

  th.sortable{
    cursor: pointer;
  }

  .evaluationToolsSortText {
    padding-top: 10px;
    font-size: 14px;
    color: #86888b;
    margin-bottom: 0;
  }
  .evaluation-tool-card {
    display: flex;
    background-color: #d9def4;
    width: 252px;
    height: 32px;
    flex-grow: 0;
    margin: 11px 518px 6px 104px;
    padding: 5px 5px 3px 2px;
    border-radius: 4px;
    color: #425cc7;

  }
  .evaluation-tool-card .tool-text {
    height: 18px;
    flex-grow: 0;
    margin: 3px 0 0 4px;
    font-family: Lato;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: left;
    color: #425cc7;
  }

  .evaluation-tool-card:hover {
    background-color: #425cc7;
    color: #d9def4;
    cursor: grab;
  }

  .evaluation-tool-card:hover .tool-text {
    color: #d9def4;
  }

  .box-shadow {
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);
  }

  .work-factors-notification {
    position: fixed;
    bottom: 10px;
    left: 15px;
    width: 430px;
    /* height: 215px; */
    border-radius: 4px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
    z-index: 1000;
    border-left: 4px solid #2dccd3;
  }

  .factor-card {
    background-color: #ffffff;
    border: 1px solid #cbcccd;
    border-radius: 4px;
  }

  .factor-card:hover {
    background-color: #f7f7f7;
    cursor: pointer;
  }

  .factor-card-blank {
    height: 32px;
    width: 100%;
    background: #edeeee;
    border-radius: 4px;
    margin: 3px;
  }

  .factor-cards-hover .factor-card-blank {
    background: #ddddde;
  }

  .video-interview-deadline-tab > a {
    border-left: 0;
    border-top: 0;
    border-right: 0;
    color: #000;
    font-weight: 600;
  }

  .video-interview-deadline-tab > a.active {
    border-bottom: 4px solid #2dccd3;
  }

  .placeholder-text-color > button  {
    color: #a9aaac;
  }

  .video-interview-template-job-name-link {
    color: #425cc7;
    text-decoration: underline;
  }

  .video-interview-card .test-card-test-name {
    background-color: #b2e5f5;
    color: #005470;
  }

  .video-interview-card-status-pill {
    border-radius: 30px;
    font-size: 12px;
    font-weight: 600;
    height: fit-content;
    padding: 5px;
  }

  .evaluator-icon {
    height: 28px;
    width: 28px;
    color: #ffffff;
    border-radius: 50%;
    display: inline-block;
    padding-top: 5px;
    text-align: center;
    font-size: 12px;
  }

  .dashboard-container {
    max-width: 1408px;
    padding: 0 24px;
  }

  .dashboard-tab-style {
    margin: 0;
  }

  .dashboard-candidates-card .dashboard-tab-style {
    padding: 0 8px;
  }

  .account-overview-card .dashboard-tab-style {
    gap: 24px;
  }

  .dashboard-tab-style > a {
    font-size: 14px;
    font-weight: bold;
    color: #53565a;
    text-align: center;
    margin-bottom: 0 !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
  }

  .dashboard-candidates-card .dashboard-tab-style > a {
    width: 50%;
    border-bottom: 1px solid #DDDDDE !important;
    padding: 13px 16px 16px 16px;
  }

  .account-overview-card .dashboard-tab-style > a {
    padding: 8px 0;
  }

  .dashboard-tab-style > .nav-link.active {
    border-bottom: 4px solid #425cc7 !important;
    color: #425cc7 !important;
  }

  .dashboard-tab-style > a:hover, .dashboard-tab-style > a:active {
    border-bottom: 4px solid #DDDDDE !important;
  }

  .dashboard-tab-style > a:active {
    background-color: #F5F7FC !important;
  }

  .table-layout-fixed {
    table-layout: fixed;
  }

  .recent-job-activity-card {
    min-width: 240px;
  }

  .dashboard-candidates-card .card-header, .recent-job-activity-card .card-header, .account-overview-card .card-header {
    color: #032876;
    background-color: white;
    font-size: 20px;
    font-weight: bold;
    padding: 16px 16px 8px 16px;
  }

  .account-overview-card > .card-header {
    padding: 16px 16px 2px 16px;
  }

  .account-overview-card .card-body {
    padding: 16px;
  }

  .account-overview-card {
    width: 100%;
  }

  .account-overview-card.dashboard {
    margin-bottom: 24px;
  }

  .account-overview-card.analytics > .card-header {
    padding: 20px 20px 0px 20px;
  }

  .account-overview-card.analytics > .card-body {
    padding: 20px;
  }

  .account-overview-card.analytics .account-overview-title {
    font-size: 16px;
    color: black;
  }

  .account-overview-card.analytics .gray-beta-badge {
    position: relative;
    top: -0.5px;
  }

  .dashboard-candidates-card .card-body {
    padding: 8px;
  }

  .dashboard-tab-card {
    border: 0 !important;
  }

  .dashboard-tab-card .card-header {
    color: #202D63;
    background-color: white;
    font-size: 16px;
    padding: 24px 8px 20px 14px;
  }

  .dashboard-candidate-msg {
    padding: 48px 16px;
    border-radius: 4px;
    border: 1px solid #DDDDDE;
    color: #53565A;
    text-align: center;
    margin: 8px;
  }

  .sapphireLinkButton {
    background-color: white;
    color: #425CC7;
    border: 0;
    padding: 0;
    font-weight: bold;
  }

  .sapphireLinkButton:hover {
    text-decoration: underline;
    background-color: white;
    color: #425CC7;
  }

  .welcome-user-text {
    color: #53565A;
    font-size: 28px;
    font-family: Montserrat;
    margin: 32px 0;
  }

  .welcome-user-text strong {
    color: #001F4E;
  }

  .keyActionsRow {
    margin: 0 0 24px 0;
    gap: 16px;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(0, 1fr));

    @media (max-width: 830px) {
      grid-template-columns: repeat(2, 1fr);
      .keyActionsRow .col-lg-3 {
        max-width: 360px;
      }
    }
  }

  .keyActionsRow .col-lg-3 {
    max-width: 100%;
  }


  .keyActionButton {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 16px;
    height: 56px;
    padding: 8px;
    border-radius: 4px;
    background-color: white;
    border: 1px solid #DDDDDE;
  }

  .keyActionButton.locked {
    background-color: #F5F7FC;
    border: 1px solid #DDDDDE !important;
    pointer-events: none;
    opacity: 1;
  }

  .keyActionButton.locked .lock {
    position: absolute;
    top: 8px;
    right: 8px;
  }

  .key-action-wrapper {
    display: block;
    width: 100%;
    height: 100%;
    cursor: default;
    position: relative;
  }

  .keyActionButton:hover {
    border: 1px solid #425CC7;
    background-color: #F5F7FC;
  }

  .keyActionButton:active {
    background-color: #ECEEF9 !important;
    border: 1px solid #DDDDDE !important;
  }

  .keyActionButton:focus {
    border: 2px solid #425CC7;
    box-shadow: none !important;
  }

  .keyActionIcon, .emptyKeyInsightIcon {
    height: 40px;
    width: 40px;
    padding: 8px;
    border-radius: 8px;
    background-color: #ECEEF9;
  }

  .keyActionIcon img {
    margin-top: 1px;
  }

  .keyActionIcon.talentInsights {
    padding: 7.5px 5px;
  }

  .keyActionIcon.talentInsights img {
    margin-top: 0;
  }

  .keyActionLabel {
    font-size: 14px;
    font-weight: bold;
    color: #202D63;
    text-align: left;

    @media (max-width: 768px) {
      font-size: 13px;
    }
  }

  .keyInsightCardDeck {
    gap: 16px;
    margin: 0;
    width: 100%;

    @media (max-width: 1038px) {
      gap: 8px;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .keyInsightCard {
    min-width: 220px;
    min-height: 208px;
    margin: 0 !important;
  }

  .keyInsightCard.skeleton .MuiSkeleton-text {
    display: inline-block;
  }

  .keyInsightCard .card-header {
    color: #53565A;
    font-size: 14px;
    font-weight: bold;
    background-color: white;
    padding: 16px;
  }

  .keyInsightCard .card-body {
    display: flex;
    flex-direction: column;
    padding: 0 16px 16px 16px;
    justify-content: space-between;
  }

  .keyInsightCard.businessValue, .keyInsightCard.businessValue .card-header,
  .keyInsightCard.lockedSI {
    background-color: #F5F7FC;
  }

  .keyInsightCard.empty .card-header, .keyInsightCard.businessValue .card-header, .keyInsightCard.lockedSI span {
    color: black;
    font-size: 14px !important;
  }

  .keyInsightCard.empty .card-header {
    display: flex;
    gap: 8px;
    align-items: center;
    padding-bottom: 16px;
  }

  .keyInsightCard.empty .card-body {
    justify-content: space-between;
  }

  .keyInsightCard.empty .empty-text {
    color: #53565A;
    margin-bottom: 0;
  }

  .keyInsightCard.businessValue .card-body {
    gap: 8px;
  }

  .keyInsightCard.businessValue p, .keyInsightCard.lockedSI p {
    color: #53565A;
    margin-bottom: 8px;
  }

  .keyInsightCard.lockedSI > .lock {
    position: absolute;
    margin: 8px 8px 0 0;
    align-self: end;
  }

  .keyInsightCard.lockedSI .si-card-content {
    padding: 16px;
  }

  .keyInsightCard.businessValue button {
    padding: 0;
    color: #425CC7;
    font-weight: bold;
  }

  .key-data-point {
    color: #202D63;
    font-size: 32px;
    font-weight: bold;
    padding-bottom: 16px;

    @media (max-width: 992px) {
      font-size: 24px;
    }
  }

  .percent-change-indicator {
    color: #53565A;
    font-size: 12px;
    font-weight: bold;
    margin: 16px 0;
  }

  .percent-change-arrow {
    border-radius: 2px;
    padding: 0px 2px 2px 2px;
    margin-right: 8px;
  }

  .percent-change-arrow.positive {
    background-color: #CCF2E1;
  }

  .percent-change-arrow.negative {
    background-color: #FAE5EE;
  }

  .sub-data-section, .action-section {
    background-color: #F5F7FC;
    border-radius: 4px;
    margin: 0;
  }

  .sub-data-section {
    height: 92px;
    padding: 8px 16px;
  }

  .action-section {
    padding: 8px 4px;
    min-height: 48px;
  }

  .action-section-button {
    border: 0;
    font-weight: bold;
    font-size: 14px;
  }

  .action-section-button img {
    margin: 0 0 3px 8px;
  }

  .sub-data-title {
    color: #53565A;
    white-space: nowrap;
    margin-bottom: 4px;
  }

  .sub-data-point {
    font-weight: bold;
    font-size: 16px;
  }

  .pending-evaluation-candidates-count {
    display: inline-block;
    background-color: #425cc7;
    color: white;
    border-radius: 100px;
    padding: 0 8px;
  }

  .recent-job-title-link {
    font-size: 14px;
    padding: 0px;
    text-decoration: none;
    width: 100%;
    text-align: left;
  }

  .vertical-dropdown-toggle {
    font-size: 16px;
    color: #53565A;
    padding: 4px 6px;
    border: 0;
  }

  .vertical-dropdown-toggle:hover {
    background-color: #ECEEF9;
    color: #425CC7;
  }

  .vertical-dropdown-toggle:active {
    background-color: #D9DEF4;
    color: #425CC7;
  }

  .no-border {
    border: 0 !important;
  }

  .no-borderTop {
    border-top: 0 !important;
  }

  .text-ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow-x: hidden;
  }

  .results-v2-parent-row {
    height: 100%;
    background-color: white;
  }

  .candidate-table-loading {
    background-color: white;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  }

  .results-v2-candidate-table {
    overflow-y: auto;
    border-bottom: 1px solid #CBCCCD;
  }

  .results-v2-candidate-table.overflowing {
    overflow-x: scroll;
  }

  .results-v2-candidate-table.overlay-showing {
    overflow-x: hidden !important;
  }

  .candidate-table-header-row > th {
    font-size: 14px;
    color: #75787b;
    border: 0 !important;
    background-color: white;
    position: sticky;
    top: 0;
    box-shadow: inset 0 -1.5px 0 #cbcccd;
    z-index: 1;
  }

  .candidate-table-header-row > th:hover {
    color: #53565a;
  }

  .overflowing .candidate-table-header-row > th:last-child {
    width: 80px;
  }

  .results-candidate-table-data-row {
    cursor: grab;
  }

  .results-candidate-table-data-row:hover,
  .results-candidate-table-data-row:hover .results-candidate-table-cell {
    background-color: #F7F7F7;
  }

  .results-candidate-table-data-row .drag-handle {
    visibility: hidden;
    display: block;
    height: 16px;
    width: 16px;
    margin-left: -1px;
  }

  .results-candidate-table-data-row:hover .drag-handle {
    visibility: visible;
  }

  .results-candidate-table-data-row > td:last-child {
    border-bottom: 1px solid #CBCCCD !important;
    border-top: 0 !important;
  }

  .results-candidate-table-cell {
    width: 160px;
    padding: 12px;
    border-bottom: 1px solid #CBCCCD !important;
    color: #53565A;
    border-top: 0 !important;
    background-color: white;
  }

  .results-candidate-table-cell .form-check {
    display: inline;
    padding-right: 12px;
  }

  .results-candidate-table-cell.rankingScore {
    width: 100px;
  }

  .results-candidate-table-cell.candidateDate {
    width: 180px;
  }

  .line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .results-candidate-table-cell [role=button] {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .results-candidate-table-cell.candidateName {
    width: 323px;
    left: 0;
  }

  td.results-candidate-table-cell.candidateName {
    position: sticky;
  }

  td.results-candidate-table-cell.candidateName.selected {
    background-color: #F7F7F7;
  }

  th.results-candidate-table-cell.candidateName {
    z-index: 2;
  }

  td.results-candidate-table-cell.candidateName {
    box-shadow: inset -2px 0 0px -1px #cbcccd;
  }

  td.results-candidate-table-cell.candidateDate {
    white-space: nowrap;
  }

  .overflowing th.results-candidate-table-cell.candidateName {
    box-shadow: inset -2px 0 0px -1px #cbcccd, inset 0 -1.5px 0 #cbcccd;
  }

  .candidateName-popover {
    font-weight: bold;
    padding: 4px 8px;
    color: #53565a;
    font-size: 16px;
    white-space: nowrap;
    display: inline-table;
  }

  .results-v2-pagination-row {
    margin: 16px 8px;
    position: sticky;
    left: 0;
  }

  .results-v2-rows-per-page {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
  }

  .disabled-pagination-break {
    pointer-events: none;
  }

  .results-v2-bulk-actions-button > #bulk-actions {
    padding: 6px 12px;
  }

  .tableFunctionText {
    color: #425cc7;
    font-weight: 600;
  }

  .video-interview-row-border {
    border-left: 1px solid #ddddde;
    border-right: 1px solid #ddddde;
  }

  .video-interview-row-border {
    border: 1px solid #ddddde;
  }

  .video-interview-row {
    border: 1px solid #ddddde;
  }

  .video-interview-row .table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
    background-color: #f7f7f7;
 }

  .video-interview-row td:last-child {
    text-align: center;
 }

  .alcamiIframeModalBody {
    max-width: '1138px';
    height: 100vh;
    padding: 0;
  }

  .alcamiIframeModalBody iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  .error-message {
    color: #d50057;
    font-weight: bold;
  }
  .warning-alert-brown {
     background-color: #fff5e5;
     color: #b27100;
  }
  .warning-alert-yellow {
    display: flex;
    background-color: #fff5e5;
    color: #805100;
    border: solid 1px #ffedcc;
    margin-top: 16px;
  }

  .warning-alert-red {
    background-color: #fae5ee;
    color: #94003c;
    border: solid 1px #f7ccdd;
  }
  .warning-alert-icon {
    font-size: 16px;
    margin: 8px;
  }
  .warning-alert-text {
    font-size: 14px;
    margin-left: 8px;
  }

  .warning-alert-yellow > .warning-alert-text {
    margin-top: 6px;
  }

  .hasOldTestsTooltip > .tooltip-inner, .hasOldTestsTooltipTestNav > .tooltip-inner {
    max-width: none;
    width: 333px;
    padding: 13px 12px;
    min-width: 24px;
    height: 100%;
    font-size: 12px;
    line-height: 18px;
    color: black;
    text-align: center;
    text-decoration: none;
    background-color: #FFF;
    border-radius: 6px;
    box-shadow: 0 0 4px #d9d9d9;
  }

.hasOldTestsTooltip > .arrow::before {
  border-bottom-color: transparent;
}

.hasOldTestsTooltipTestNav > .arrow::before {
  border-top-color: transparent;
}

.valueStatementText {
  color: #6c757d;
}

.video-interview-circle-count {
  color: #005470;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  font-weight: bold;
  background: #99DDF3;
  margin-right: 5px;
  display: inline-grid;
  align-content: center;
  justify-content: center;
}

.tableFunctionText {
  color: #425cc7;
  font-weight: 600
}

.video-interview-row {
  border: 1px solid #ddddde;
}

.video-interview-row .table-hover tbody tr:hover td, .table-hover tbody tr:hover th {
  background-color: #f7f7f7;
}

.alcamiIframeModalBody {
  height: 100vh;
  padding: 0;
}

.alcamiIframeModalBody iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.error-message {
  color: #d50057;
  font-weight: bold;
}

.warning-alert-brown {
  background-color: #fff5e5;
  color: #b27100;
}

.evaluator-row img {
  vertical-align: text-top;
}

.existing-work-factors-box {
  background-color: #eaf9fa;
  padding: 12px;
}

.existing-work-factors-header {
  height: 16px;
  align-self: stretch;
  flex-grow: 0;
  font-family: Lato;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  letter-spacing: 1px;
  text-align: left;
  color: #166669;
}

.existing-work-factors-text {
  height: 20px;
  align-self: stretch;
  flex-grow: 0;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  line-height: 1.43;
  text-align: left;
  color: #000;
}

.clpt-skill-modules-box {
  border-radius: 4px;
  background-color: #ECEEF9;
  padding: 12px;
}

.clpt-skill-modules-header {
  font-size: 12px;
  font-weight: 700;
  color: #202D63;
  margin-bottom: 12px;
}

.clpt-skill-module-row {
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #425CC7;
  background-color: #F5F7FC;
  margin: 24px 0 0 0;
}

.clpt-skill-module-row .form-check-input {
  height: 14px;
  width: 14px;
}

.clpt-skill-module-row .form-check-input:checked {
  accent-color: #425CC7;
}

.clpt-skill-module-row .form-check-label {
  font-weight: bold;
  font-size: 14px;
  margin-top: 1.5px;
}

.shareResultsConfirmationModal > .modal-dialog {
  max-width: 600px;
}

.timezoneDropdown > .dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
}

.reminder-tag {
  font-size: 13px;
  font-weight: bold;
  vertical-align: middle;
  background-color: #fff5e5;
  border: 0.5px solid #ffd17f;
  border-radius: 4px;
  padding: 2px 3px;
  text-align: center;
}

.report-data .react-grid-Cell__value {
  white-space: pre !important;
}

/* ---------- Dynamic Score Reports ---------- */

.scale-cell-orange-striped {
  background: repeating-linear-gradient(
    135deg,
    #ffb533,
    #ffb533 3px,
    #ffffff 3px,
    #ffffff 6px
  );
}

.scale-cell-green-striped {
  background: repeating-linear-gradient(
    135deg,
    #00c067,
    #00c067 3px,
    #ffffff 3px,
    #ffffff 6px
  );
}

.scale-cell-orange {
  background-color: #ffb533 !important;
}

.scale-cell-light-green {
  background-color: #4cd395;
}

.scale-cell-green {
   background-color: #00c067 !important;
}

.scale-cell-dark-green {
  background-color: #009952;
}

.scale-cell-green-striped {
    background: repeating-linear-gradient(
    135deg,
    #4ecd87,
    #4ecd87 3px,
    #ffffff 3px,
    #ffffff 6px
  ) !important;
}

.scale-label-cell {
  padding: 5px 2px !important;
  text-align: center;
}

.scale-bracket {
  height: 10px;
  border-bottom: 1px solid #b5b7b7;
  border-left: 1px solid #b5b7b7;
  border-right: 1px solid #b5b7b7;
  margin: 10px 1.5px 10px 0;
}

.scale-label {
  color: #53565a;
  text-align: center;
}

.score-scale-row {
  clear: both;
  list-style: none;
  margin: 0 0 25px 0;
  padding: 0;
}

.score-scale-row li {
  border-right: 1px solid white;
  height: 20px;
  padding: 0;
  margin: 0;
  float: left;
}

.numbered li {
  background-color: #ccd2dc;
}

.numbered-score-scale-label-row {
  list-style: none;
  margin: 0;
  padding: 0;
}

.numbered-score-scale-label-row li {
  color: #828283;
  font-size: 10px;
  height: 14px;
  padding: 0;
  margin: 4px 0 0 0;
  float: left;
  text-align: right;
}

.numbered-score-scale-label-row li span {
  position: relative;
  right: -5px;
  display: block;
}

.numbered-score-scale-label-row.wpp li:nth-child(odd) {
  opacity: 0;
}

#numbered-score-label-zero {
  position: relative;
  color: #828283;
  font-size: 10px;
  top: -14px;
}

.scale-score-bubble {
  width: 32px;
  height: 32px;
  border-radius: 15px;
  border: 1px solid white;
  background-color: #011f4e;
  color: #fff;
  text-align: center;
  font-weight: strong;
  position: relative;
  top: -64px;
  margin-left: -13px;
  padding-top: 5px;
  z-index: 10;
  margin-bottom: -22px;
}

.scale-score-range-highlight-green {
  height: 20px;
  background-color: #00c067;
  position: relative;
  z-index: 8;
  opacity: 0.8;
  top: -68px;
}

.score-report-job-row {
  color: #001f4e;
  border-radius: 4px;
  margin-left: -1px;
}

.score-report-job-row:hover {
  background-color: #d9def4 !important;
  cursor: pointer;
}

.score-report-job-row.active {
  color: #FFF !important;
  background-color: #00c067 !important;
}

.score-report-job-row.active:hover {
  background-color: #009952 !important;
}

.score-report-job-container > .score-report-job-row:nth-child(odd) {
  background-color: #eceef9;
}

.score-report-job-container > .score-report-job-row:nth-child(even) {
  background-color: #f5f7fc;
}

.talent-mobility-score-range-container {
  background-color: #e5e8ed;
  padding: 18px 25px 28px 16px;
  margin-left: 14px;
  border-bottom-right-radius: 20px;
}

.trait-header {
  border-radius: 0px 0px 20px 0px;
  border: 1px solid #e0e1e5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #001f4e;
  font-weight: bold;
}

.trait-header.score-explanation {
  width: 75%;
  padding: 0px 15px;
  margin: 0 16px;
}

.trait-header.score-detail {
  padding: 20px 15px;
  margin-bottom: 12px;
}

.job-family-selected {
  background-color: #00c067 !important;
  color: #FFF !important;
}

.score-detail-section-heading {
  font-size: 22px;
  color: #001f4e;
  font-weight: bold;
  padding: 4px 0 6px 0;
}

.score-detail-subsection-heading {
  font-size: 16px;
  color: #02215a;
  font-weight: bold;
  margin-bottom: 12px;
}

.criteria-navy-color {
  color: #001f4e !important;
}

#dynamicScoreReportsScoreRanges > .dropdown-toggle:after {
  float: right;
  margin-top: 8px;
}

.traitDescriptionBox {
  background-color: #e5e8ed;
  border-radius: 0px 0px 20px 0px;
  padding: 12px 0px;
}

.reportHeader {
  display: inline-block;
  color: #19355f;
  font-weight: 600;
  font-size: 21px;
}

.badge-interview {
  background-color: #011f4e;
  color: #fff;
  font-size: 15px;
  margin-bottom: 10px;
}

.work-factor-key-circle {
  display: inline-block;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  margin-right: .5rem;
}

.level-of-importance-bar {
  height: 6px;
  border-radius: 0px 3px 3px 0px;
}

.waa-level-of-importance-key{
  display:flex;
  position: relative;
  left: 45%;
  margin: 10px 0px;
}

.results-summary-box-header {
  display: flex;
  justify-content: center;
  color: white;
  text-align: center;
  font-weight: bold;
  padding: 16px 0;
}

.red-warning-icon-white-bg {
  height: 16px;
  width: 16px;
  margin: -3px 4px 0 0;
}

.summary-score-box {
  text-align: center;
  color: #001f4e;
  border-radius: 0 0 20px 0;
  background-color: #e5e8ed;
  margin-right: 10px;
  padding: 12px 0 16px 0;
}

.summary-score-box > p {
  font-size: 16px;
  padding: 0 5px;
  margin-bottom: 0;
}

.summary-score-box.Proficiency {
  padding-top: 30px;
}

.summary-score-box.Proficiency > p {
  margin-top: 12px;
}

.results-summary-row {
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  color: #001f4e;
  border-radius: 0 0 20px 0;
  background-color: #e5e8ed;
  padding: 12px 0;
}

.results-summary-row > .col {
  text-align: center;
}

.standardScoreCol {
  padding: 10px 15px;
}

.standardScoreCol > strong {
  font-size: 24px;
}

.standardScoreCol.Proficiency {
  margin-top: 0.5px;
}

.standardScoreCol.withDivider {
  border-left: 2px solid #b2bbc9;
}

.standardScoreCol > p {
  margin-bottom: 0;
  font-size: 15px;
}

.results-summary-row > .col.jobFamilyMatch > p {
  font-weight: bold;
  padding-bottom: 4px;
  margin-bottom: 0;
  font-size: 18px;
}

.proficiency-col {
  border-right: 1px solid #b5b7b7;
}

.proficiency-col:last-child {
  border-right: none;
}

.proficiency-col > ul {
  padding-inline-start: 15px;
}

.proficiency-col > ul > li {
  margin-bottom: 20px;
}

.currentCheckCircle {
  margin: 0 4px 1px -1.5px;
}

.exceededCheckCircle {
  margin: 0 7px 1px 0;
}

/* ---------- Typing test Styles ---------- */

.double-list{
  column-count: 2;
  width: 100%;
  column-gap: 5%;
  margin-top: 8px;
}

.double-list>li{
  margin-bottom: 8px;
}

.candidate-work-factor-bg-color{
  background-color: #2DCCD3;
}

.organization-work-factor-bg-color{
  background-color: #001F4E;
}

.dsr-skills-test-badge {
  background-color: #425cc7;
  color: white;
}

.score-report-results-details-list>li{
  margin-bottom:25px;
}

.pole-text{
  white-space: break-spaces;
}

.incorrect-data-entered {
  font-weight: bold;
  color: red;
  text-decoration: line-through;
}

.sr-h5 {
  color: #19355f;
  font-size: 16px;
  font-weight: 600;
}

.selected-score-range-box {
  border-radius: 0px 0px 20px 0px;
  font-size: 16px;
  font-weight: bold;
}

.selected-score-range-box.office365 {
  background-color: #19355f;
  color: #FFF;
  padding: 8px 0 8px 8px;
  max-width: 130px;
  margin-right: 40px;
}

.selected-score-range-box.epp {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  margin-left: -1px;
  background-color: #e5e8ed;
  padding: 16px 8px;
  color: #001f4e;
}

.selected-score-range-box.epp:hover {
  background-color: #f5f7fc !important;
  cursor: pointer;
}

.wps-text-percentile span {
  color: #425cc7;
  font-weight: 600;
}

.colored-raw-score-bubble{
  width: 100%;
  display: flex;
  justify-content: center;
}

.colored-raw-score-bubble>div{
  white-space: nowrap;
  text-align: center;
  display: inline-block;
  font-weight: bold;
  width: 100%;
  z-index: 10;
  color: white;
  position: relative;
  background-color: #011f4e;
  height: 30px;
  width: 30px;
  aspect-ratio: 1;
  top: -5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.scale-cell {
  border-left: 1px solid white;
  border-right: 1px solid white;
}

/* ---------- Typing test Styles ---------- */

span.deletion {
  font-weight: bold;
  color: #1f8245;
  text-decoration: underline;
}

span.insertion {
  font-weight: bold;
  color: red;
  text-decoration: line-through;
}

/* ---------- Average Scale Wrapper Styles ---------- */

.average-score-scale-wrapper {
  padding: 0;
  margin-bottom: 24px;
}

.candidate-summary.average-score-scale-wrapper {
  margin-top: -18px;
}

.average-score-scale-wrapper .scale-label {
  font-size: 14px;
}

.candidate-summary.average-score-scale-wrapper .scale-label {
  font-size: 12px;
}

.average-score-scale-wrapper .scale-score-bubble {
  margin-top: -50px;
  margin-left: -34px;
}

.candidate-summary.average-score-scale-wrapper .scale-score-bubble {
  margin-top: -45px;
}

.score-report-row {
  padding: 16px 0;
  margin: 0 4px;
  border-top: 1px solid #a9aaac;
}

.gray-bottom-border {
  border-bottom: 1px solid #a9aaac;
}

.dynamic-score-report-nav-bar {
  border-bottom: 1px solid #cbcccd;
  height: 40px;
  justify-content: flex-start;
  margin: 16px 4px 0 4px;
}

.dynamic-score-report-nav-tab,
.dynamic-score-report-nav-tab:focus,
.dynamic-score-report-nav-tab:hover {
  font-size: 14px;
  color: black;
  text-decoration: none;
  padding: 6px 16px;
  border-radius: 0;
}

.dynamic-score-report-nav-tab.active {
  font-weight: bold;
  border-bottom: 2px solid #2dccd3;
}

.competency-score-summary-row {
  margin: 0 20px 0 50px;
}

.competency-score-summary-row > .competency-score-column:nth-child(odd)  {
  margin-right: 55px;
  margin-left: -60px;
}

.competency-score-column {
  padding: 0;
}

.dynamic-score-report-error {
  text-align: center;
  margin: 48px auto 16px auto;
  width: 600px;
}

  /* ---------- Results V2 ---------- */

.results-v2-bulk-actions-button > #bulk-actions {
  font-weight: bold;
}

.results-v2-navigation-button {
  color: #425cc7;
  font-size: 14px;
  font-weight: bold;
}

.results-v2-candidate-overlay {
  position: absolute;
  top: 0px;
  left: 326px;
  background-color: #FFF;
  border: 1px solid #ddddde;
  z-index: 2;
  overflow-y: auto;
  overflow-x: hidden;
}

.candidate-overlay-slide-enter {
  transform: translateX(100%);
  transition: transform 300ms ease-out;
}

.candidate-overlay-slide-enter-active {
  transform: translateX(0%);
}

.candidate-overlay-slide-exit {
  transform: translateX(100%);
  transition: transform 300ms ease-out;
}

.results-v2-close-button {
  border: solid 1px #425cc7;
  border-radius: 4px;
  padding: 5px 9px 8px 9px;
  position: absolute;
  top: 35px;
  right: 23px;
  z-index: 100;
}

.results-v2-close-button-tooltip  {
  height: 24px;
  border-radius: 2px;
  left: -22px !important;
}

.results-v2-close-button-tooltip > .tooltip-inner {
  background-color: #F7F7F7;
  color: black;
  padding: 5px 8px;
  margin-top: 2px;
  box-shadow: 3px 3px 8px 1px rgb(0 0 0 / 25%);
}

.results-v2-close-button-tooltip > .arrow {
  display: none;
}

.results-v2-navigation-dropdown > .dropdown-menu {
  transform: translate3d(0px, 32px, 0px) !important;
  max-height: 239px;
  overflow-y: scroll;
  width: 100%;
}

.results-v2-move-dropdown > .dropdown-menu {
  overflow-y: scroll;
}

.max-width-280px {
  display: flex;
  max-width: 280px;
  justify-content: space-between;
}

.overlay-view-icons {
  display: flex;
  height: 16px;
  padding-right: 5px;
  margin-top: 3px;
}

.overlay-view-icons-slide-enter {
  transform: translateX(30%);
  transition: transform 350ms ease-out;
}

.overlay-view-icons-slide-enter-active {
  transform: translateX(0%);
}

.overlay-view-icons-slide-exit {
  opacity: 0;
  transition: opacity 75ms;
}

.results-v2-candidate-name {
  font-weight: bold;
  color: #53565A !important;
  font-size: 16px;
  border: 0;
  padding: 0;
}

.results-v2-candidate-name.selected {
  text-decoration: none !important;
}

.results-v2-candidate-icon {
  color: #999;
  font-size: 13.5px;
  margin: -7px 5px 0 0;
}

.results-v2-popover, .auth0-config-form-popover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  font-size: 12px;
  padding: 8px 12px;
}

.results-v2-popover>.arrow{
  display:none;
}

.results-v2-candidate-email {
  font-size: 14px;
  color: #53565A;
}

.results-v2-candidate-email:hover > .email-copy-icon{
  visibility: visible;
}
.email-copy-icon{
  visibility: hidden;
}

.email-copy-icon,
.email-copy-icon-success{
  padding-left: 5px;
  margin-top: 2px;
  box-sizing: content-box;
}


.rdp-button:hover:not([disabled]):not(.rdp-day_selected) {
  background-color: #ECEEF9 !important;
}

.rdp-dropdown:focus-visible:not([disabled]) + .rdp-caption_label {
  background-color: #ECEEF9 !important;
  border: 2px solid #425CC7 !important;
}
.in-range-badge{
  width: 120px;
  height: 32px;
}

/* -------------------- Score Range Display Row for DSR -------------------- */

.score-range-display-row, .score-range-display-row>div{
  display: flex;
}
.score-range-display-row > div:nth-child(-n+2) {
  min-width: 250px;
  border-right: solid 1px #989a9c;
}

.score-range-display-row .score-range-display-text{
  padding: 0px 25px;
}

.score-range-display-row > div:last-child {
  flex-grow: 1;
  justify-content: flex-end;
  align-content: center;
  flex-wrap: wrap;
  margin-left: 25px;
}

.score-range-display-row .score-range-icon{
  height: 48px;
}
.score-range-display-row .parameters{
  white-space: break-spaces;
}

.score-range-display-row span{
  color: #001f4e;
  font-size: 13px;
  display: block;
  line-height: 20px;
}

.score-range-display-row .grey-text{
  color: #53565a;
  font-size: 12px;
  line-height: 18px;
}

.score-range-display-row .bold-text{
  line-height: normal;
  font-weight: bold;
}

.test-report-sales-assessment-overview {
  display: flex;
}

.test-report-sales-assessment-overview ul{
  padding-top: 1rem;
}

.test-report-sales-assessment-overview-lists ul{
  column-count: 2;
  padding-top: 10px;
  margin: 0 60px 0 85px;
}

.test-report-sales-assessment-overview li{
  list-style: none;
  padding-bottom: 1rem;
}
.sales-strengths-icons{
  height: 30px;
  aspect-ratio: 1;
}

.test-report-sales-assessment-overview-key .sales-strengths-icons{
  height: 16px;
}
.test-report-sales-assessment-overview-lists .sales-strengths-icons{
  height: 25px
}
.test-report-sales-assessment-overview-lists{
  flex-grow: 1;
  padding: 0px 25px;
}

.score-details-table .score-bars{
  height: 30px;
  top: -30px;
}

.score-details-table .score-bars{
  height: 34px;
  top: -26px;
}

.score-details-table .scale-score-bubble{
  top: -60px;
  margin-bottom: -17px;
}
.trait-score-row{
  border: 1px solid #e5e8ed;
  border-bottom-right-radius: 15px;
  padding: 10px 0;
  color: #19355f;
  font-size: 16px;
  font-weight: 600;
  margin: 15px 0;
}

.trait-score-row-number{
  margin-right: 1rem;
  text-align: right;
  font-size: 18px;
}


.score-detail-mrab-trait-row,
.score-detail-mrab-trait-row>div{
  display: flex;
}

.score-detail-mrab-trait-row{
  flex-direction: column;
}
.score-detail-mrab-trait-row>div{
  align-items: center;
}

.cast-score-detail-section{
  column-count: 2;
}
.cast-score-detail-section>div{
  display: inline-block;
}
.cast-score-detail-section strong{
  color: #19355f;
}

.trait-container{
  border: 1px solid #e5e8ed;
  border-bottom-right-radius: 15px;
  padding: 20px;
}

.trait-container h5 {
  color: #011f4e;
  margin: 15px 0;
  font-weight: 600;
}

.emailPreviewBox {
  min-height: 300px;
  font-size: 12px;
  color: #333;
  border: 1px solid gray;
  padding: 10px 10px 10px 10px;
  background-color: #fff;
}

/* Use important to override the style for react-autosuggest input for job title */
.job-title-input-error input {
  border-color: #d50057!important;
}

.rc-slider-tooltip {
  z-index: 9999 !important;
}

.ruleFiltersDropdown-noValue > .dropdown-toggle {
  color: #86888b !important;
}

.ruleFiltersDropdown-noValue.show.dropdown > .dropdown-toggle {
  color: #fff !important;
}

/* ---------- StageCard classes ---------- */

.stageCard {
  height: 36px;
  min-height: 36px;
  font-size: 12px;
  color: black;
  margin-right: 5px;
  margin-bottom: 2px;
  float: left;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 5px;
  text-align: left;
  position: relative;
  background: #C6D0E4 url("https://s3.amazonaws.com/criteria-static-web-assets/results/pipeline_arrow_off_no_border.png") top right no-repeat;
}

.stageCard.active {
  font-weight: 600;
  background: #FFF url("https://s3.amazonaws.com/criteria-static-web-assets/results/pipeline_arrow_on_no_border.png") top right no-repeat;
  border-left: 6px solid #143E97;
}

.stageCard.lastStage {
  background: #C6D0E4;
}

.stageCard.lastStage.active {
  border-left: 6px solid #143E97;
  background: #FFF;
}

.stageCard.allOrNotHired {
  background: #dbdbdc;
  margin-left: 16px;
}

.stageCard.allOrNotHired.active {
  border-left: 6px solid #4d4d4f;
  background: #FFF;
}

.stageCard > .stageName {
  float: left;
  margin-top: 4px;
  margin-right: 4px;
}

.stageCard.allOrNotHired > .stageName.resultsV2 {
  font-size: 16px;
  margin: 6px 0 0 1px;
  font-weight: normal;
}

.stageCardDivider {
  display: block;
  margin-bottom: -.4em;
}

.completedCount, .allOrNotHiredName {
  font-weight: normal;
  float: left;
}

.completedCount {
  font-size: 24px;
  margin-right: 8px;
}

.allOrNotHiredName {
  font-size: 16px;
  margin-top: 0.3em;
}

.pendingCount {
  font-size: 10px;
  font-weight: normal;
  color: #828283;
}

.candidateSchedulingModal > .modal-dialog {
    max-width: 600px;
}

#eventExpirationHelpDocBtn {
  background-color: #fff;
  color: #425cc7;
  font-weight: bold;
  border: none;
}

/* ---------- Set Test Event Expiration Component ---------- */
.setEventExpirationRadioBtn > .form-check-input {
  margin-right: 6px !important;
}

.selectEventExpirationByDays {
  border: 1px solid #dfdfdf;
  border-radius: 4px 4px 0px 0px;
  border-bottom: none;
  padding: 16px;
}

.selectEventExpirationByDateTime {
  border: 1px solid #dfdfdf;
  border-radius: 0px 0px 4px 4px;
  padding: 16px;
}

.selectedEventExpiration {
  border-color: #a0ade3;
  background-color: #f5f7fc;
}

.dropdown > #reminderEmailDropdown {
  border-color: #cccccc;
}

.selectedEventExpiration.selectEventExpirationByDays ~ .selectEventExpirationByDateTime {
  border-top-color: #a0ade3;
}

/* ---------- Time Pick Input Component ---------- */

input[readonly].timePickerInput {
  background-color: #fff !important;
}

.customBootstrapModalSizeLg > .modal-dialog {
  max-width: 700px;
}

#jobEventExpiredTooltip.tooltip.show {
  opacity: 1 !important;
}

#jobEventExpiredTooltip > .tooltip-inner {
  max-width: none;
  width: 333px;
  padding: 13px 12px;
  min-width: 24px;
  height: 100%;
  font-size: 12px;
  line-height: 18px;
  color: black;
  text-align: center;
  text-decoration: none;
  background-color: #FFF;
  border-radius: 6px;
  border: solid 1px #dfe2e5;
  box-shadow: 0 10px 20px 0 rgba(28, 28, 28, 0.15);
}

#jobEventExpiredTooltip > .arrow::before {
  border-right-color: transparent !important;
}

.timePicker .MuiPickersToolbar-toolbar, .MuiPickersClock-pin, .MuiPickersClockPointer-pointer, .MuiPickersClockPointer-noPoint, .MuiPickersClockPointer-thumb {
  background-color: #425cc7 !important;
}

.dateTimeInputDialog {
  background-color: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 0.25rem;
  position: absolute;
  top: 100%;
  z-index: 1000;
  min-width: 100%;
}

#ATSIntegrationsSettingsPopover {
  border-radius: 4px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  background-color: #f7f7f7;
}

#ATSIntegrationsSettingsPopover > .arrow::after {
  border-top-color: #f7f7f7;
}

.VI-locked-corner {
  background-color: #eceef9;
  height: 150px;
  right: -75px;
  position: absolute;
  top: -75px;
  width: 150px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.VI-merchandizing-modal > .modal-dialog, .SI-merchandizing-modal > .modal-dialog {
  max-width: 700px;
}

.VI-send-email {
  margin: 5px 8px 0 0;
}

/* ---------- Integrations classes ---------- */

.integration-card-header {
  font-size: 24px;
  font-weight: bold;
  background-color: white;
  padding: 24px 20px 4px 20px;
}

.integration-preview {
  justify-content: end;
  padding: 24px 16px 8px 16px;
}

.integration-preview-row {
  background-color: #F7F7F7;
  height: 33px;
  padding: 8px 16px;
  margin-bottom: 4px;
  margin-right: 0;
  justify-content: start;
  font-size: 14px;
}

.integration-preview-row > span {
  color: #53565A;
}

.integration-preview-row > span:first-child {
  color: black;
  font-weight: bold;
  margin-right: 8px;
}

.gray-border-top {
  border-top: 1px solid #DFDFDF;
}

.gray-border-bottom {
  border-bottom: 1px solid #DFDFDF;
}

.integration-page-button {
  color: #425CC7;
  text-decoration: underline;
  padding: 4px 12px;
  font-weight: bold;
}

.integration-page-button:hover {
  color: #425CC7;
  background-color: rgba(66, 92, 199, 0.1);
}

.lever-stage-label {
  font-size: 15px;
  font-weight: bold;
  margin-right: 16px;
}

.lever-required-msg {
  color: #86888B;
  width: 300px;
  margin-left: 15px;
  margin-top: -6px;
}

.bambooHr-status-select-div {
  margin-bottom: 16px;
}

.status-select {
  width: 500px;
  margin-top: 2px;
}

.lever-status-select {
  width: 300px;
  margin-top: -6px;
}

.status-select.package {
  width: 470px;
}

.default-status-check {
  margin: 3px 0 0 2px;
}

.default-status-check > .form-check-label {
  margin-top: 2px;
}

.integration-button-row {
  justify-content: end;
  margin-right: 4px;
}

.integration-button-row > .integration-page-button {
  margin-right: 16px;
}

.job-mappings-section {
  margin-top: 24px;
  padding-top: 24px;
}

.mapping-button-popover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
  font-size: 12px;
  padding: 8px 12px;
}

.mapping-button-popover > .arrow {
  display: none;
}

.integration-h3 {
  font-weight: bold;
  font-size: 20px;
}

.faded {
  opacity: 0.5;
}

.package-column {
  background-color: #EDEEEE;
  border-radius: 4px;
  padding-top: 16px;
  max-width: 500px;
}

.job-opening-link {
  border: 0;
  padding: 0;
  text-decoration: underline;
  color: #425CC7;
  text-align: left;
}

.jobMappingActionDropdown {
  display: flex;
  justify-content: end;
}

.jobMappingActionDropdown > .dropdown-menu {
  padding: 0;
}

.jobMappingActionDropdown > .dropdown-menu > .dropdown-item {
  padding: 12px 24px;
}

.jobMappingDeleteDropdownItem {
  border-top: 1px solid rgba(0,0,0,.15);
  color: #D50057;
}

.same-status-trigger-error {
  margin-top: 4px;
  margin-left: 2px;
  color: #dc3545;
}

.job-mapping-list {
  list-style-type: none;
  font-weight: bold;
  padding-top: 8px;
  padding-left: 0;
  margin: 0;
}

.candidate-summary-button-wrapper {
  margin-top: 20px;
  margin-bottom: 1rem;
  margin-right: 2rem;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  border-bottom: solid 1px rgb(222, 226, 230);
}

.search-input-component {
  border-left: none;
  padding-left: 0;
  height: 100%;
}

.search-input-component:focus {
  border-color: #ced4da;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.copyCandidateConfirmationModal > .modal-dialog {
  max-width: 600px;
}

.modal-fullwidth{
  max-width: 100%;
  margin: 0;
}

.dropdown-toggle-no-background {
  background-color: transparent !important;
  border: none !important;
}

.talentSignalSIWrapper {
  border: 3px solid #425cc7;
  border-radius: 4px;
  margin: 10px;
}

.talentSignalEvalToolToggleWrapper {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

/* ---------- Structured Interview classes ---------- */

.evaluator-assignment-dropdown > .dropdown-toggle {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.evaluator-assignment-dropdown > .dropdown-menu {
  width: 200px;
}

.fontAwesome-icon-svg-img-wrapper {
  padding-right: 5px;
  width: 20px;
}

.resultsTabContentWrapper .tab-pane.candidate-summary {
  padding: 0 0.5rem;
}

.resultsTabContentWrapper .interview.tab-pane,
.resultsTabContentWrapper .interview .tab-pane {
  padding: 0;
}

.resultsTabContentWrapper .tab-pane {
  padding: 0 1.5rem;
}

.dashboard-vi-merch-card {
  padding: 16px 24px;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  border: solid 3px #425cc7;
}

.dashboard-vi-merch-card > .upper-right-triangle {
  position: absolute;
  top: -60px;
  right: -70px;
  width: 120px;
  height: 120px;
  transform: rotate(45deg);
  background: #eceef9;
}

.dashboard-vi-merch-card > .lock {
  position: absolute;
  top: 15px;
  right: 15px;
}

.dsr-vi-merch-card {
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px;
  margin-top: 20px;
  border: solid 3px #00A9E0;
}

.dsr-vi-merch-card > div {
  display: flex;
  gap: 16px;
  margin-right: 24px;
}

.merch-card-mobile-ctn {
  flex-direction: column;
}

.results-vi-merch-icon {
  height: 48px;
  width: 48px;
}

.contact-button-box-header {
  width: 100%;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  height: 36px;
  background-color: #2E408A;
  color: #FFF;
  font-family: Lato;
  padding: 8px 16px;
}

.contact-button-box-header:hover {
  background-color: #394EA1 !important;
}

.auth0SamlConfigFormLabel {
  vertical-align: top;
}

.auth0SamlConfigFormControl {
  vertical-align: bottom;
}

.ssoSettingsFormLeftColStyle {
  font-size: 14px;
  line-height: 20px;
  font-weight: bold;
  text-align: right;
  margin-bottom: 32px;
}

.ssoSettingsFormRightColStyle {
  font-size: 14px;
  line-height: 20px;
  text-align: left;
  margin-bottom: 32px;
}

.ssoAttributeMappingBox {
  padding: 10px;
  border: 1px solid #cacaca;
  border-radius: 4px;
  color: #828283;
}

.ssoAttributeMappingRow {
  border-bottom: 1px solid #dbdbdc;
  line-height: 1.5;
  letter-spacing: normal;
  color: #000;
  padding: 15px;
}

.auth0SamlInstructionsCode {
  background-color: #f5f5f5;
  padding: 5px;
  font-family: monospace;
}

.auth0SamlInstructionsTable {
  table-layout: fixed;
  width: 100%;
}

.auth0SamlInstructionsTable td:first-child {
  width: 30%; /* Set the width of the first column to 30% */
}

.auth0SamlInstructionsTable td:last-child {
  width: 70%; /* Set the width of the second column to 70% */
}

.auth0SamlInstructionsTable thead tr {
  padding: 10px; /* Add some padding */
  background-color: #f5f5f5; /* Set a background color */
  border-bottom: 1px solid #ddd; /* Add a bottom border */
}

.auth0SamlInstructionsTable thead td {
  padding: 10px; /* Add some padding */
  font-weight: bold; /* Add a bold font */
}

.auth0SamlInstructionsTable thead th {
  padding: 10px; /* Add some padding */
  text-align: left; /* Center the text */
  border-right: 1px solid #ddd; /* Add a right border */
}

.auth0SamlInstructionsTable thead th:last-child {
  border-right: none; /* Remove the right border */
}

.auth0SamlInstructionsTable tbody tr:nth-child(even) {
  background-color: #f2f2f2; /* Set a background color for even rows */
}

.auth0SamlInstructionsTable tbody td {
  padding: 10px; /* Add some padding */
  text-align: left; /* Center the text */
  border-right: 1px solid #ddd; /* Add a right border */
}

.auth0SamlInstructionsTable tbody td:last-child {
  border-right: none; /* Remove the right border */
}

input[type="file"]::file-selector-button {
  cursor: pointer;
}

#phoneNumberLocaleDropdown {
  border: none !important;
  background-color: #fff !important;
  color: #000 !important;
}

#phoneNumberLocaleDropdown::after {
  margin-left: 8px !important;
}

.text-bubble {
  position: relative;
  width: 100%;
  background: #e9e9eb;
  border-radius: 18px;
  padding: 6px 12px;
  color: #000;
  font-size: 16px;
}

.text-bubble-bottom-left:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 12px solid #e9e9eb;
  border-right: 6px solid transparent;
  border-top: 6px solid #e9e9eb;
  border-bottom: 10px solid transparent;
  left: 8px;
  bottom: -12px;
}

.react-toggle-small {
  transform: scale(0.7);
}

.react-toggle-set-small {
  position: relative;
  left: -.5em;
  padding: .25em 0;
}

.edit-candidate-modal > .modal-dialog {
  max-width: 600px;
}

.AI-suggestion-information-box {
  display: flex;
  padding: 16px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid #C6CEEE;
  background: #ECEEF9;
}

.tss-welcome-banner-card .card-body {
  padding: 32px 24px 24px 24px;
}

.tss-welcome-banner-card .card-body h2 {
  color: #001F4E;
  line-height: 42px;
  font-family: 'Montserrat';
}

.tss-welcome-banner-component-wrapper {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  margin: auto;
  padding: 1rem 3rem;
  flex-wrap: wrap;
  gap: 24px;
}

.solution-text {
  width: 320px;
  height: 72px;
}

.tss-welcome-banner-component {
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 4px;
  padding: 1rem 2rem;
  flex: 1;
  flex-basis: 0;
  max-width: 350px;
}

.tss-welcome-banner-component h4 {
  font-weight: 700;
  font-size: 21px;
  color: #0f2554;
  align-self: center;
  margin-bottom: 0;
  padding: 0 1rem;
}

.tss-welcome-banner-action-button {
  font-weight: bold;
  color: #425cc7;
  text-decoration: none;
}

.tss-welcome-banner-action-button img {
  margin-left: 8px;
  align-self: center;
}

#tss-welcome-banner-schedule-a-call-button {
  text-decoration: underline;
  top: 0;
}

.candidate-profile-si-merch-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #eceef9;
  padding: 8px 16px;
  margin: 8px 15px;
  border-radius: 4px;
  border-left: 6px solid #425CC7;
}

.candidate-profile-si-merch-banner-buttons > .btn-outline-primary {
  border: none;
}

.cannotDeleteAnswerTypeModal.modal.fade {
  background: rgba(0, 0, 0, 0.5);
}

.cannotDeleteAnswerTypeModal.modal-backdrop.fade {
  opacity: 0;
}

.no-table-header {
  display: none;
}

.prompt-input-section > p {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 4px;
}

.help-assistant-disclaimer-text {
  color: #86888b;
  font-size: 13px;
}

.prompt-input-form-group .input-group-append .btn.btn-primary {
  background: #FFF;
  border: 1px solid #ced4da !important;
  border-left: 0px !important;
  opacity: 1 !important;
}

.generated-response .span-label {
  padding: 4px;
  background-color: #D9DEF4;
  border-radius: 4px;
  font-weight: 700;
}

button#forgotPassword[disabled]{
  cursor: not-allowed;
}

.analytics-title-wrapper {
  font-family: 'Montserrat';
  font-size: 28px;
  font-weight: 700;
  color: #001F4E;
  line-height: 42px;
}

.analytics-nav-bar {
  display: flex;
  border-bottom: 1px solid #D9DEF4;
  padding: 16px 16px 8px 0px;
}

.analytics-nav-item-wrapper:focus {
  outline: none !important;
  box-shadow: none !important;
}

.analytics-nav-item {
  padding: 18px 0px 10px 0px;
  margin: 0px 12px;
  gap: 14px;
  font-weight: 700;
  font-size: 16px;
  border-bottom: transparent;
  color: #53565A;
}

.analytics-nav-item.active {
  border-bottom: 3px solid #202D63;
  color: #202D63;
}

.analytics-nav-item-anchor {
  display: block;
  position: relative;
  top: -250px;
  visibility: hidden;
}

.analytics-section .section-wrapper {
  border-top: 1px solid #DDDDDE;
}

.analytics-section .section-header {
  font-weight: 700;
  font-size: 20px;
  line-height: 30px;
}

.completion-funnel-type-selection button {
  border-radius: 4px;
  padding: 4px 8px;
  font-weight: 700;
}

.completion-funnel-type-selection button.active {
  color: #202D63;
  border: 2px solid #425CC7;
}

.completion-funnel-type-selection button.inactive {
  color: #53565A;
  border: 2px solid #DDDDDE;
}

.completion-funnel-type-selection button:focus {
  outline: none;
  box-shadow: none;
}

.completion-funnel-type-selection .type-text::before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    margin-right: 5px;
    border-radius: 50%;
    vertical-align: middle;
}

.completion-funnel-type-selection #text-invited::before {
  background-color: #202D63;
}

.completion-funnel-type-selection #text-open-link::before {
  background-color: #2DCCD3;
}

.new-analytics-dashboard-dropdown .dropdown-toggle {
  white-space: normal;
  text-align: left;
}

/* overwrite the default pseudo class toggle icon */
.new-analytics-dashboard-dropdown .dropdown-toggle::after {
  margin: auto 0 !important;
  border-top: 0.4em solid !important;
  border-right: 0.4em solid transparent !important;
  border-bottom: 0 !important;
  border-left: 0.4em solid transparent !important;
}

.new-analytics-dashboard-dropdown.interview-data-form .dropdown-toggle::after {
  display: none !important;
}

.new-analytics-dashboard-dropdown .dropdown-menu.show {
  width: 100%;
}

.new-analytics-dashboard-dropdown .dropdown-menu.show .actionDropdownItem.dropdown-item{
  padding: 0.5rem 1rem;
  color: #001F4E !important;
  white-space: normal;
}

.new-analytics-dashboard-dropdown .dropdown-menu.show .actionDropdownItem.dropdown-item:hover {
  background-color: #ECEEF9;
}

.new-analytics-dashboard-dropdown.interview-data-form .dropdown-menu.show .actionDropdownItem.dropdown-item {
  color: #000 !important;
  &:hover {
    background-color: #F7F7F7;
  }
}

.completion-funnel-banner-style {
  color: #202D63;
  padding: 12px 16px;
  background-color: #F5F7FC;
  border: 1px solid #B3BEE9;
  border-radius: 4px;
}

.analytics-graph-wrapper-card .Loader {
  z-index: 0;
}

.test-volume-bar-chart-wrapper {
  margin: 0;
  padding: 2em 0;
  padding-top: 0;
  border: 1px solid #DFDFDF;
  border-radius: 4px;
  display: flex;
}

.test-volume-bar-chart {
  width: 100%;
  margin-left: 1em;
}

.responsive-container-wrapper {
  width: 100%;
  overflow-y: auto;
  position: relative;
}


.responsive-container-wrapper.show-fade::after {
  content: '';
  position: sticky;
  display: block;
  width: 90%;
  bottom: 0;
  left: 0;
  right: 0;
  height: 40px; /* Height of the fade effect */
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
}

.recharts-custom-tooltip {
  width: 300px;
  background: #FFF;
  padding: 10px;
  box-shadow: 2px 2px 10px 0px rgba(1, 18, 44, 0.40);
  border-radius: 4px;
}

.sampleCSVTemplateDownload {
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #C6CEEE;
  background-color: #ECEEF9;
  padding: 8px 16px;
}

#csvTemplateDownloadBtn {
  display: flex;
  align-items: center;
  text-decoration: underline;
  padding: 8px 0;
  font-weight: 700;
  color: #202D63;
}

.file-upload-success::after {
  content: "\u2713";
  color: #00C067;
  padding-left: 4px;
}

.import-candidates-success-modal > .modal-dialog {
  max-width: 600px;
}

.success-oval-background {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00C067;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.billing-details-modal-form .form-label {
  margin-bottom: 0;
  font-weight: 700;
}

.billing-details-modal-form.was-validated .form-control.is-invalid {
  border-color: #dc3545 !important;
}

.billing-details-modal-form.was-validated .form-control.is-invalid:focus {
  box-shadow: 0 0 0 0.2rem rgba(220,53,69,.25) !important;
}

.order-summary-table tr  {
  height: 50px;
}

.order-summary-table tr td {
  padding-left: 0;
  vertical-align: middle;
}

.order-summary-table tr td:first-child {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}

.smallText {
  color: #6c757d;
  font-size: 14px;
};

.completion-funnel-container-wrapper {
  padding: 50px 50px 30px 50px;
  width: 100%;
  border: 1px solid #DDDDEE;
  border-radius: 4px;
}

.completion-funnel-container-wrapper #job-funnel-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin-bottom: 20px;
}

.analytics-feedback-option {
  border: 1px solid #425CC7;
  border-radius: 4px;
  padding: 6px 11px;
  margin-right: 8px;
  text-align: center;
}

.sms-consent-modal > .modal-dialog {
  max-width: 600px;
}

.comparison-benchmark-filter-search-dropdown {
  cursor: auto !important;
  width: 100%;
  text-align: left;
  padding: 0.5em;
  border-top: 1px solid #D9DEF4;
}

.comparison-benchmark-filter-search-dropdown:focus {
  outline: none !important;
}

.metric-card-comparison-section {
  padding-top: 1rem;
  margin-top: 1rem;
  border-top: 1px solid #DDDDDE
}

.new-analytics-dashboard-comparison-filter.dropdown-menu.show {
  max-height: 300px;
  overflow-y: auto;
}

.test-performance-selection-button {
  padding: 8px 16px;
  font-size: 13px;
  border-radius: 100px;
  font-weight: 700;
}

.test-performance-selection-button.active {
  border: 1px solid #425CC7;
  color: #425CC7;
  background-color: #ECEEF9;
}

.test-performance-selection-button.inactive {
  border: 1px solid #A9AAAC;
  color: #53565A;
}

.test-performance-graph-card-wrapper {
  padding: 2em;
  border: 1px solid #DFDFDF;
  border-radius: 4px;
}

.completion-section-insights-tips-card {
  max-width: 333px;
  background-color: #EAF9FA;
  border: none;
  border-radius: 4px;;
  font-size: 13px;;
  color: #125254;
}

.completion-section-insights-tips-card .card-header,
.completion-section-insights-tips-card .list-group .list-group-item,
.completion-section-insights-tips-card .card-footer {
  background-color: #EAF9FA;
  border: none;
  color: #125254;
  font-size: 13px;
}

.country-dropdown-items {
  display: flex;
  justify-content: space-between;
}

.country-dropdown-items  div:first-child {
  margin-right: 1rem;
}

.reuse-results-job-modal > .modal-dialog {
  max-width: 600px;
}

.branding-modal > .modal-dialog {
  max-width: 560px !important;
}

.landing-page-modal-col {
  display: flex;
  flex-direction: column;
}

.landing-page-iframe {
  border: 1px solid #BABBBD;
  box-shadow: 0px 4px 6px rgba(66, 92, 199, 0.08);
}

.occupation-card {
  box-sizing: border-box;
  border: 1px solid #D9DEF4;
  border-radius: 4px 4px 32px;
  border-left-width: 4px;
  display: flex;
  flex-direction: column;
}

.occupation-card:hover {
  background-color: #F5F7FC;
  cursor: pointer;
}

.occupation-card:hover h4, .occupation-card:hover p, .occupation-card:hover ul {
  color: #000 !important;
}

.occupation-card.skeleton-card:hover {
  background-color: #FFF;
}

.occupation-card ul {
  padding-left: 20px;
  margin-bottom: 0px;
}

.occupation-card.selected {
  border: 1px solid #425CC7;
  border-left-width: 4px;
  background-color: #F5F7FC;
}

.occupation-card.selected h4, .occupation-card.selected p, .occupation-card.selected ul {
  color: #000 !important;
}

.occupation-card-button {
  display: flex;
  align-items: center;
  border-width: 2px;
  height: 40px;
  font-size: 14px;
  font-weight: 700;
}

.occupation-card-button.selected {
  background-color: #D9DEF4;
  border: none;
}

.occupation-card-more-info-button {
  border-radius: 4px;
  font-size: 14px;
  font-weight: 700;
}

.occupation-card-more-info-button:hover {
  background-color: #ECEEF9;
  color: #425CC7;
}

.occupation-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(320px, 1fr));
  grid-gap: 20px;
}

.occupation-search-input {
  position: relative;
  width: 100%;
}

.occupation-search-input #clearOccupationSearchBtn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 4;
}

.occupation-search-input #clearOccupationSearchBtn:hover {
  background-color: #F7F7F7;
}

.xl-size-modal > .modal-dialog {
  max-width: 1100px;
}

.xl-size-modal .modal-content {
  height: 80vh;
}

.custom-batteries-tab-container.job-profiler-v2 {
  display: flex;
  justify-content: center;
  height: 1000px;
}

.custom-batteries-tab-container.job-profiler-v2 > #custom-battery-tab-empty-state {
  padding: 150px 16px;
}

.ksa-info-tooltip {
  padding: 4px 8px;
  font-size: 12px;
  border-color: transparent;
  border-radius: 4px;
  box-shadow: 2px 2px 10px 0px rgba(1, 18, 44, 0.40);
  max-width: 350px;
}

#customizeBatteryPopoverTip {
  padding: 4px 8px;
  background-color: #F7F7F7;
  color: #53565A;
  border-radius: 4px;
  box-shadow: 2px 2px 10px 0px rgba(1, 18, 44, 0.40);
  border-color: transparent;
  font-size: 12px;
  max-width: none;
}

#customizeBatteryPopoverTip > .arrow::after {
  border-top-color: #F7F7F7;
}

.job-success-modal > .modal-dialog {
  max-width: 600px;
}

.job-success-modal-link-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.landing-page-confirmation-modal {
  background-color: #EAF9FA;
  color: #125254;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 2px 4px 0px #00000026;
}

.landing-page-confirmation-modal-info-icon {
  margin-top: 2px;
}

.toast-notification-ctn {
  position: fixed;
  min-width: 400px;
  bottom: 4rem;
  right: 0px;
  margin: 1rem;
  z-index: 100;
}

.toast-element {
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
}

.manager-guide-card-header {
  height: 2rem;
  display: flex;
  align-items: center;
  background-color: #001F4E;
  color: #FFF;
  margin-top: 24px;
  padding: 10px 24px 10px 24px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.manager-guide-header-text {
  color: #000;
  font-size: 20px;
  font-family: Lato;
  font-weight: 700;
  word-wrap: break-word;
}

.manager-guide-intro-text {
  width: 100%;
  color: #000;
  font-size: 13px;
  font-family: Lato;
  font-weight: 400;
  word-wrap: break-word;
  margin-top: 16px;
}

.manager-guide-card-content {
  padding: 24px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.tip-header {
  color: #000;
  font-size: 16px;
  font-weight: 700;
  word-wrap: break-word;
  margin-left: 8px;
  margin-bottom: 0px;
}

.tip-ctn {
  display: flex;
}

.conversation-starters-ctn {
  margin-top: 16px;
}

.conversation-starters-item {
  padding-left: 16px;
  margin-bottom: 4px;
}

.conversation-header {
  color: #4D4D4F;
  font-size: 14px;
  font-family: Lato;
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
}

.modal-md > .modal-dialog {
  max-width: 600px;
}

.evaluator-expanded {
  background-color: #EDEEEE;
}

.template-selection-pill {
  flex-grow: 1;
  border-radius: 50px;
  padding: 8px 30px;
  gap: 10px;
  font-size: 16px;
}

.template-selection-pill.selected {
  background-color: #C6CEEE;
  color: #425CC7;
}

.template-selection-pill:not(.selected) {
  background-color: #F7F7F7;
  color: #75787B;
}

.merchandising-callout-ctn {
  margin-top: 24px;
}

.merchandising-callout-ctn-inner {
  padding: 24px;
  background: #EAF9FA;
  font-size: 14px;
  word-wrap: break-word;
  line-height: 20px;
  font-weight: 400;
  color: #166669;
  border: 1px solid #D5F5F6;
  display: flex;
  align-items: center;
}

.merchandising-callout-bulb-icon {
  height: 24px;
  width: 24px;
}

.merchandising-callout-text {
  margin: 0;
  margin-left: 16px;
}

.merchandising-callout-span {
  font-weight: 700;
  text-decoration: underline;
}

.manager-guide-nav-item {
  display: flex;
}

.manager-guide-badge {
  margin-left: 8px;
  font-weight: 700;
}

.move-candidate-to-hire-modal-title{
  margin: 0;
  color: #032468;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
}

.simple-form-label{
  font-size: 14px;
  font-weight: 700;
  color: #53565A;
}

.move-candidate-to-hire-modal-info-box{
  background-color: #F5F7FC;
  color: #202D63;
  padding: 12px 16px;
}

.move-candidate-to-hire-modal-info-box > .toggle-container{
  display: flex;
  gap: 16px;
  align-items: center;
}


.avatar-circle {
  display: flex;
  justify-content: center;
  aspect-ratio: 1;
  border-radius: 50%;
}

.avatar-circle.initials {
  background-color: #53565a;
  align-items: center;
  color: white;
}

.avatar-circle > img {
  border: solid 2px #fff;
}

.avatar-circle,
.avatar-circle > img {
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 14px;
  border: solid 1px #fff;
}

.manager-dropdown-option{
  display:flex;
  gap:10px;
  padding: 4px;
}

.manager-dropdown-option__text-container__name{
  font-size: 13px;
  color: #001F4E;
}

.manager-dropdown-option__text-container__role{
  font-size: 12px;
  color: #53565A;
}

.manager-dropdown-option__text-container__name,
.manager-dropdown-option__text-container__role{
  font-weight: 400;
  margin:0;
}

.move-candidate-to-hire-modal__empty-card{
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #F7F7F7;
  flex-direction: column;
  gap:4px;
  text-align: center;
}

.move-candidate-to-hire-modal__empty-card p{
  margin-bottom: 0;
  color: #53565A;
  max-width: 340px;
}

.move-candidate-to-hire-modal__empty-card-description{
  font-size: 12px;
  font-weight: 400;
}

.move-candidate-to-hire-modal__empty-card-title{
  font-size: 16px;
  font-weight: 700;
}

.move-candidate-to-hire-modal__success-screen{
  display:flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
}

.move-candidate-to-hire-modal__success-screen-title{
  font-size: 16px;
  font-weight: 700;
  color: #001F4E;
  margin-bottom: 0;
}

.move-candidate-to-hire-modal__success-screen-info-text{
  color: black;
  font-size: 14px;
  margin-bottom: 0;
  max-width: 560px;
  text-align: center;
}

.move-candidate-to-hire-modal__success-screen-action-button{
  display: flex;
  gap: 16px;
  margin: 10px 0;
}

.move-candidate-to-posthire-dropdown-option{
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 160px;
}

.move-candidate-to-hire-modal__info-popover{
  min-width: 334px;
  padding: 16px;
}

.move-candidate-to-hire-modal__info-popover-content-title{
  font-weight: 700;
}
.move-candidate-to-hire-modal__info-popover-content-recommended{
  padding: 12px 16px;
  border-radius: 4px;
  background-color: #F7F7F7;
  color: #202D63;
}

.move-candidate-to-hire-modal__info-popover-content-recommended > p{
  margin-bottom: 0;
}

.redirect-to-develop-option{
  color: #53565A;
  display: flex;
  align-items: flex-start;
}

.create-job-header-progress-dot {
  background-color: #DDDDDE;
  border-radius: 50%;
}

.create-job-header-progress-dot.completed {
  background-color: #425CC7;
}

.create-job-header-progress-dot.current {
  background-color: #FFF;
  border: 2px solid #425CC7;
}

.job-creation-progress-dot-tooltip {
  padding: 4px 8px;
  font-size: 12px;
  border-color: transparent;
  border-radius: 4px;
  box-shadow: 2px 2px 10px 0px rgba(1, 18, 44, 0.40);
  max-width: 350px;
}

.cyan-tag {
  color: #166669;
  font-weight: 700;
  font-size: 12px;
  background-color: #D5F5F6;
  border-radius: 4px;
  padding: 3px 4px;
}

.sapphire-banner {
  color: #425CC7;
  border-radius: 4px;
  background: #D9DEF4;
  padding: 12px 0;
}

.flex-gap-24 {
  gap: 24px;
}

.flex-gap-16 {
  gap: 16px;
}

.flex-gap-8 {
  gap: 8px;
}

.border-width-2 {
  border-width: 2px;
}

.helper-text {
  color: #53565A;
  font-size: 13px;
  font-weight: 400;
  line-height: 19px;
}

.btn-text-link {
  color: #425cc7;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    text-decoration: underline !important;
    background: transparent;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.65;
  }
}

.secondaryActionBtn {
  min-height: 40px;
  border: 1px solid transparent;
  padding: 0 2px !important;
  font-weight: 700;
}

.secondaryActionBtn:hover {
  background-color: transparent;
  border: 1px solid transparent;
}

.secondaryActionBtn > span {
  text-decoration: underline;
  font-size: 14px;
}

.secondaryActionBtn:hover > span {
  text-decoration: none;
}

.secondaryActionBtn:focus {
  border: 1px solid #B3BEE9;
  border-radius: 4px;
}

.secondaryActionBtn:active {
  color: #2E408A !important;
  background-color: transparent !important;
  border: 1px solid transparent !important;
}

.text-learn-more {
  color: #425cc7 !important;
  text-decoration: underline;
  font-weight: 700;
}

.automated-beta-tag {
  background-color: #FFF;
  font-size: 12px;
  color: #86888B;
  padding-left: 0px;
}


`;
